import React, { useEffect, useRef, useState } from "react";
import MainComponent from "../MainComponent";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import InputField from "./InputField";
import Arrow from "../../assets/images/arrow-circle-down.svg";
import ArrowSIMP from "../../assets/images/arrow-bottom.svg";
import Repeat from "../../assets/images/repeat.svg";
import Assign from "../../assets/images/assign.svg";
import Calendar from "../../assets/images/Calendar.svg";
import Asana from "../../assets/images/asana.png";
import AddIcon from "../../assets/images/add.svg";
import SubtasksIcon from "../../assets/images/subtasks_icon.svg";
import XLExeuctionPlanSidebar from "./XLExecutionPlanSidebar";
import Select from "react-select";
import AddColorIcon from "../../assets/images/plus-fill.svg";
import keys from "../../utils/helpInfoKeys.json";
import DatePicker from "react-datepicker";
import { v4 as uuidv4 } from "uuid";
import { motion } from "motion/react";
import Dialog from "@mui/material/Dialog";
import { SlCalender } from "react-icons/sl";
import { BsSearch, BsFilter, BsChevronDown } from "react-icons/bs";
import { DialogContent, DialogTitle } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { TbRepeat } from "react-icons/tb";
import Checkbox from "@mui/material/Checkbox";
import { RiEditBoxLine } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import { TiDelete } from "react-icons/ti";

import {
  getRandomColor,
  createImageFromInitials,
  StepProgressBar,
} from "../Utils";
import {
  createStatus,
  createProgressBar,
  createPriority,
} from "./WorkboardProgress";
import UserProfile from "../../assets/images/user-profile.svg";
import ChevronRight from "../../assets/images/Chevron-right.svg";
import TaskSidebar from "./TaskSidebar";
import {
  getEmployeeData,
  getExistingFunctions,
  getExportWorkboardCsvfile,
  getMasterTaskPriorityAndStatusData,
  getOverdueTaskDetails,
  getTaskDetails,
  getWorkboardDetails,
  postStrategyFunctions,
  resetExceptionError,
  getAiGeneratedGoals,
  postAiTaskGeneratedGoals,
  postBulkTaskUpdate,
} from "../../store/actions";
import "./XLExecutionPlan.css";
import "./WorkBoard.css";
import DisabledGoalSelector from "./DisabledGoalSelector";
import Login from "../Login";
import SideNavHelpInfo from "../../utils/SideNavHelpInfo";
import { Button, OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import DuplicateTaskPopup from "./DuplicateTaskPopup";
import Alert from "../Alert";
import TextField from "@mui/material/TextField";

import Drawer from "@mui/material/Drawer";
import { HiSparkles } from "react-icons/hi2";
import { AiOutlineCaretLeft, AiOutlineCaretRight } from "react-icons/ai";
import { RESET_AI_GENERATED_GOALS,RESET_BULK_TASK_UPDATE_SUCCESS } from "../../store/actions/actionTypes";



function Workboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const biIdParams = searchParams.get("bi_id");
  const productIdParams = searchParams.get("product_id");
  const taskIdParams = searchParams.get("task_id");
  const parentTaskIdParams = searchParams.get("parent_task_id");
  const functionParams = searchParams.get("function_id");
  const selectedHelpInfoSidebar = useSelector(
    (state) => state.selectedHelpInfoSidebar
  );
  const [selectedFunction, setSelectedFunction] = useState(null);
  const [empData, setEmpData] = useState(null);
  const [collapsedItems, setCollapsedItems] = useState({});
  const [newTaskName, setNewTaskName] = useState("");
  const [newTaskDueDate, setNewTaskDueDate] = useState(null);
  const [isTaskSidebarOpen, setIsTaskSidebarOpen] = useState(false);
  const [highlightedRowIndex, setHighlightedRowIndex] = useState(null);
  const [selectedTaskId, setSelectedTaskId] = useState({});
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedFunctionStyle, setSelectedFunctionStyle] = useState(null);
  const [isNewTask, setIsNewTask] = useState(false);
  const [statusData, setStatusData] = useState([]);
  const [priorityData, setPriorityData] = useState([]);
  const [breadcrumbs, setBreadcrumbs] = useState("");
  const [selectedTaskMilestoneId, setSelectedTaskMilestoneId] = useState("");
  const [taskIndex, setTaskIndex] = useState("");
  const [isSubTaskVisible, setIsSubTaskVisible] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [milestoneData, setMilestoneData] = useState([]);
  const [taskType, setTaskType] = useState("");
  const [subTaskId, setSubTaskId] = useState("");
  const [functionData, setFunctionData] = useState([]);
  const [newTaskOwner, setNewTaskOwner] = useState("");
  const [currentImperativeIndex, setCurrentImperativeIndex] = useState();
  const [currentMilestoneIndex, setCurrentMilestoneIndex] = useState();
  const [currentTaskIndex, setCurrentTaskIndex] = useState();
  const [mileStonesData, setMileStonesData] = useState([]);
  const [currentParentTaskIndex, setCurrentParentTaskIndex] = useState();
  const [currentSubTaskIndex, setCurrentSubTaskIndex] = useState();
  // const [isDropdownVisible, setDropdownVisible] = useState(false); // Controls main dropdown visibility
  // const [isNestedVisible, setNestedVisible] = useState(false); // Controls nested options visibility
  const [userPermission, setUserPermission] = useState("");
  const [userDueDatePermission, setUserDueDatePermission] = useState("");
  const [empId, setEmpId] = useState("");

  const [imperativeName, setImperativeName] = useState("");
  // const fetchgetExportWorkboardCsvFile = useSelector(
  //   (state) => state.fetchgetExportWorkboardCsvFile
  // );
  const fecthPostDuplicateTasksData = useSelector(
    (state) => state.fecthPostDuplicateTasksData
  );
  const fetchPostBulkTaskUpdate=useSelector(
    (state)=> state.fetchPostBulkTaskUpdate
  )
  const [showDuplicateTaskPopup, setShowDuplicateTaskPopup] = useState(false);
  const [duplicateTaskId, setDuplicateTaskId] = useState("");
  const [duplicateTaskName, setDuplicateTaskName] = useState("");
 //const [aiFunctionName, setAiFunctionName] = useState("");
//const [aiFunctionId, setAiFunctionId] = useState("");

  const [showAiTaskGenerate, setShowAiTaskGenerate] = useState(false);
const [aiTaskEdit, setAiTaskEdit] = useState(false);
const [generatedTasks, setGeneratedTasks] = useState([]);
const [selectedMilestoneForAI, setSelectedMilestoneForAI] = useState(null);
  
  const [showAiGenerate, setShowAiGenerate] = useState(false);
  const [aiEdit, setAiEdit] = useState(false);
 const [goals, setGoals] = useState([]);
  const [aiFullScreenMode, setAiFullScreenMode] = useState(false)
  const [aiButtonEnabled, setAiButtonEnabled] = useState(false);
 // const [showAiTaskModal, setShowAiTaskModal] = useState(false);
 const aiGeneratedTasks = useSelector((state) => state.fetchGetAiGeneratedGoals);

//const [aiTaskCount, setAiTaskCount] = useState("");
  const [isBulkEditMode, setIsBulkEditMode] = useState(false);
  const [selectedTaskIds, setSelectedTaskIds] = useState([]);// to select bulk of tasks 
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkFields, setBulkFields] = useState({ 
  assigned_to: null,  
  priority: null,
  status:null,
  start_date: null,
  due_date:null,
  progress: null,
  });
  
  const fetchgetChatbot = useSelector((state) => state.fetchgetChatbot);
  
  const aiGeneratedGoals = useSelector((state) => state.fetchGetAiGeneratedGoals);
  
  const fetchPostCreateAiTaskGeneratedGoals = useSelector((state) => state.fetchPostCreateAiTaskGeneratedGoals);
  const isInitialLoad = useRef(true);
  const dropdownRef = useRef(null); // Create a reference for the dropdown
  useEffect(() => {
    const response = JSON.parse(localStorage.getItem("userDetails"));
    const employe_Id = response?.data?.emp_id;
    setEmpId(employe_Id);
  }, [localStorage.getItem("userDetails")]);

  // const toggleDropdown = () => {
  //   setDropdownVisible(!isDropdownVisible);
  // };

  // const toggleNested = () => {
  //   setNestedVisible(!isNestedVisible);
  // };
  useEffect(() => {
    if (
      fetchPostBulkTaskUpdate &&
      fetchPostBulkTaskUpdate.status === "Success"
    ) {
      const defaultDueDateCount =fetchPostBulkTaskUpdate.default_due_date_count || 0;
      const skippedStatusCount =fetchPostBulkTaskUpdate.skipped_status_count || 0;
      const skippedDueDateCount =fetchPostBulkTaskUpdate.skipped_due_date_count || 0;

      Alert.success({
        title: "Bulk edit completed",
        icon:"success",
        html: `
      
   <div style="font-size:14px; color:#344054; line-height:1.6;"> 

  
          
        ${
          skippedStatusCount > 0
              ? `
                <div style="
                  padding:10px 12px;
                  margin-bottom:10px;
                  background:#F8FAFC;
                  border-radius:8px;
                  color:#667085;
                ">
                Completed status was updated only for tasks without subtasks or with all subtasks Completed.
                </div>
              `
              : ""
          }

          ${
            skippedDueDateCount > 0
              ? `
                <div style="
                  padding:10px 12px;
                  margin-bottom:10px;
                  background:#F8FAFC;
                  border-radius:8px;
                  color:#667085;
                ">
                 Only permitted tasks were updated for the due date.
                </div>
              `
              : ""
          }

      ${defaultDueDateCount > 0
            ? `
            <div style="
              padding:10px 12px;
              background:#F8FAFC;
              border-radius:8px;
              color:#667085;
            ">
         
      ${defaultDueDateCount} child task${defaultDueDateCount > 1 ? "s had" : " had"} a due date exceeding ${defaultDueDateCount > 1 ? "their" : "its"} parent due date and ${defaultDueDateCount > 1 ? "were" : "was"} defaulted to match the parent task's due date.
            </div>
          `
            : ""
          }
      ${(skippedStatusCount === 0 && skippedDueDateCount === 0 && defaultDueDateCount === 0) ? "All tasks updated succesfully." : ""}



    </div>
  `,
        showIcon: false,
        preConfirm: (isConfirm) => {
          if (isConfirm) {
            dispatch({ type: RESET_BULK_TASK_UPDATE_SUCCESS })
          } else {
          }
        },
      });
       if (
        localStorage.getItem("bi_id") &&
        localStorage.getItem("product_id") &&
        localStorage.getItem("selectedfunction")
      ) {
        dispatch(
          getWorkboardDetails(
            localStorage.getItem("bi_id"),
            localStorage.getItem("product_id"),
            localStorage.getItem("selectedfunction"),
            radioValue === "2" ? "my_tasks" : "",
            filters
          )
        );

      }
    
     

    }
   
  }, [fetchPostBulkTaskUpdate]);
  useEffect(() => {
    if (
      fecthPostDuplicateTasksData &&
      fecthPostDuplicateTasksData.status === 200
    ) {
      if (
        localStorage.getItem("bi_id") &&
        localStorage.getItem("product_id") &&
        localStorage.getItem("selectedfunction")
      ) {
        dispatch(
          getWorkboardDetails(
            localStorage.getItem("bi_id"),
            localStorage.getItem("product_id"),
            localStorage.getItem("selectedfunction"),
            radioValue === "2" ? "my_tasks" : "",
            filters
          )
        );
        dispatch(
          getMasterTaskPriorityAndStatusData(
            localStorage.getItem("bi_id"),
            localStorage.getItem("product_id"),
            localStorage.getItem("selectedfunction")
          )
        );
      }
    }
  }, [fecthPostDuplicateTasksData]);
  useEffect(() => {
    if (
      (biIdParams,
      productIdParams,
      taskIdParams,
      parentTaskIdParams,
      functionParams)
    ) {
      dispatch(
        getMasterTaskPriorityAndStatusData(
          localStorage.getItem("bi_id"),
          localStorage.getItem("product_id"),
          localStorage.getItem("selectedfunction")
        )
      );
      localStorage.setItem("workboard_filter", 2);
      localStorage.setItem("bi_id", biIdParams);
      localStorage.setItem("product_id", productIdParams);
      localStorage.setItem("selectedfunction", functionParams);
      dispatch(getTaskDetails(taskIdParams));
      setIsNewTask(false);
      setIsTaskSidebarOpen(true);
      setSelectedTaskId(taskIdParams);
      setSelectedTaskMilestoneId(parentTaskIdParams);
      setBreadcrumbs("Task");
      setHighlightedRowIndex(taskIdParams);
    }
  }, [
    biIdParams,
    productIdParams,
    taskIdParams,
    parentTaskIdParams,
    functionParams,
  ]);

  useEffect(() => {
    if (fetchgetChatbot && fetchgetChatbot?.status == 200) {
      if (fetchgetChatbot.message === "chatbot not enabled") {
        setAiButtonEnabled(false);
      } else {
        setAiButtonEnabled(true);
      }
    }
  }, [fetchgetChatbot]);

  
  const handleShowAiTaskGenerateOpen = (milestone

  ) => {
      setShowAiGenerate(true);
    };
  const handleShowAiTaskGenerateClose = () => setShowAiGenerate(false);
  
  const handleAiEdit = () => {
      setAiEdit(false);
      setShowAiGenerate(false);
      dispatch({ type: RESET_AI_GENERATED_GOALS });
      setTimeout(() => {
        setGoals([]);
      }, 300);
    };
  
  
  useEffect(() => {
      if (aiGeneratedGoals?.tasks_json?.length > 0 && !aiEdit){
        setGoals(aiGeneratedGoals.tasks_json);
  
        setAiEdit(true);
      }
    }, [aiGeneratedGoals]);
  

  useEffect(() => {
  if (fetchPostCreateAiTaskGeneratedGoals && fetchPostCreateAiTaskGeneratedGoals?.status === 'Success') {
    
    handleAiEdit();
    setTimeout(() => {
       window.location.reload(); 
    }, 800); 
  }
}, [fetchPostCreateAiTaskGeneratedGoals]);

  

  const GenerateMilestoneTasksPanel = ({ handleshowAiGenerateClose, milestoneItem }) => {
    // Move all the specific generation states here
    const [prompt, setPrompt] = useState("");
    
    
    
    
   const [taskCount, setTaskCount] = useState("2-5");
    const taskCountOptions = [
      { value: "2-5", label: "2 - 5" },
      { value: "3-6", label: "3 - 6" },
      { value: "5-7", label: "5 - 7" },
    ];

    const handleAiSubmit = (event) => {
      event.preventDefault();
      

      const bi_id = localStorage.getItem("bi_id");
      const product_id = localStorage.getItem("product_id");

     if (bi_id && product_id && milestoneItem?.id) {
        dispatch(
          getAiGeneratedGoals(
            bi_id,
            product_id,
            prompt,
            null,           // fg (not needed for tasks)
            null,           // haveFg (not needed for tasks)
            null,           // fgCount (not needed for tasks)
            null,           // msCount (not needed for tasks)
            null,           // functionName
            "task",         // generation_type logic
            milestoneItem.id, // milestone_id
            taskCount       // task_count selected by user
          )
        );
      }
    };
    
    return (
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // marginBottom: "20px",
            borderBottom: "1px solid lightGray",
            padding: "0 20px",
          }}
        >
          <div
            style={{
              fontSize: "var(--text-font-size)",
              fontWeight: "var(--heading-font-weight)",
            }}
          >
            Generate Tasks for: {milestoneItem?.name}
          </div>
          <div style={{ display: "flex", justifyContent: "end", gap: "20px" }}>
            <Button
              form="ai-form"
              type="submit"
              style={{
                backgroundColor: "var(--button-primary-color)",
                width: "fit-content",
              }}
            >
              Generate
            </Button>

            <button
              style={{
                border: "none",
                // borderRadius: "20px",
                // backgroundColor: "white",
                background: "none",
                fontSize: "36px",
                // marginBottom: "10px",
              }}
              onClick={() => {
                handleshowAiGenerateClose();
              }}
            >
              &times;
            </button>
          </div>
        </div>

        {/* Content */}
        <form
          id="ai-form"
          style={{ padding: "20px" , flexGrow:'1',
            overflowY:'auto',
            overflowX:'hidden',
            paddingBottom:'100px'}}
          onSubmit={(event) => handleAiSubmit(event)}
        >
          <div sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

            <div className="ai-instructions">
              <div className="ai-instructions-title">
                How the AI will generate milestone tasks
              </div>

              <div className="ai-instructions-text">
                Provide context to help the AI produce actionable execution tasks tailored to this specific milestone.
              </div>

              <ul className="ai-instructions-list">
                <li>Specify technical constraints or required tools</li>
                <li>Include quality standards or specific "Definition of Done"</li>
                <li>Mention dependencies on other teams or functions</li>
                <li>Indicate the preferred level of granularity for the tasks</li>
              </ul>
            </div>
            <div><div
              style={{
                marginBottom: "5px",
                marginRight: "20px",
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              Provide any additional instructions or requirements for AI:
            </div>
            <TextField
              name="prompt"
              // label="Describe what you want to generate..."
              multiline
              rows={10}
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              fullWidth
            /></div>
            

           
          
            <div style={{marginBottom:'200px'}} >
              <div
              style={{
                marginBottom: "5px",
                marginRight: "20px",
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              How many tasks should be generated for this milestone:
            </div>
               {"  "}
              <Select
                required
                className="ms-select"
                placeholder={
                  <span style={{ fontSize: "var(--text-font-size)" }}>
                    Select Task Count
                  </span>
                }
                value={taskCountOptions.find((opt) => opt.value === taskCount) || null}
                options={taskCountOptions}
                onChange={(selected) => setTaskCount(selected.value)}
                getOptionLabel={(e) => (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span
                      style={{
                        marginLeft: 5,
                        fontSize: "var(--sub-heading-font-size)",
                      }}
                    >
                      {e.label}
                    </span>
                  </div>
                )}
              />
            </div>

            
          </div>
        </form>
      </>
    );
};


  const selectedBI = useSelector((state) => state.selectedBI);
  const getExistingFunctionsData = useSelector(
    (state) => state.getExistingFunctionsData
  );
  const selectedSubMenuPermission = useSelector(
    (state) => state.selectedSubMenuPermission
  );
  const renderTooltip = (props) => (
    <Tooltip id="username-tooltip" {...props}>
      Actions
    </Tooltip>
  );
  const getEmployeeDetails = useSelector((state) => state.getEmployeeDetails);
  const [biName, setBIName] = useState(null);

  const steps = ["Step 1", "Step 2", "Step 3", "Step 4", "Step 5", "Step 6"];

  const WorkboardData = useSelector((state) => state.WorkboardData);
  const getMasterTasksPriorityAndStatusDetails = useSelector(
    (state) => state.getMasterTasksPriorityAndStatusDetails
  );
  const isFunctionDataFetched = useSelector(
    (state) => state.isFunctionDataFetched
  );
  const postStrategyFunctionDetails = useSelector(
    (state) => state.postStrategyFunctionDetails
  );

  const OverdueTaskData = useSelector(
    (state) => state.fetchGetOverdueTaskDetails
  )

  const [imparativeData, setImperativeData] = useState([]);
  const [showNewTaskInput, setShowNewTaskInput] = useState(
    Array(imparativeData.length).fill(false)
  );

  const tools = [{ name: "Asana", value: "asana", imgSrc: Asana }];
  const filters_data = [
    { name: "All Tasks", value: "1" },
    { name: "My Tasks", value: "2" },
  ];
  const [radioValue, setRadioValue] = useState(
    localStorage.getItem("workboard_filter")
  );
  const [filters, setFilters] = useState({
    milestone: "",
    owner: "",
    due_from:"",
    due_to: "",
    progress: "",
    status: "",
    priority: "",
  });
  const handleFilterChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };
  const ALL_OPTION = { value: "", label: "All" };
  const withAllOption = (options) => [ALL_OPTION, ...(options || [])];
  // Single setFilters call so clearing all filters triggers only one refetch
  const clearFilters = () => {
    setFilters({
      milestone: "",
      owner: "",
      due_from: "",
      due_to: "",
      progress: "",
      status: "",
      priority: "",
    });
  };
  const [showFilters, setShowFilters] = useState(false);
  // due_from/due_to are one filter (a range), so they count once
  const activeFilterCount = [
    filters.milestone,
    filters.owner,
    filters.due_from || filters.due_to,
    filters.progress,
    filters.status,
    filters.priority,
  ].filter(Boolean).length;
  useEffect(() => {
    if (!localStorage.getItem("workboard_filter")) {
      localStorage.setItem("workboard_filter", "2");
      setRadioValue(localStorage.getItem("workboard_filter"));
    }
  }, []);
  useEffect(() => {
    const bi_id = localStorage.getItem("bi_id");
    const product_id = localStorage.getItem("product_id");
    if (bi_id && product_id && selectedFunction) {
      dispatch(
        getWorkboardDetails(
          bi_id,
          product_id,
          selectedFunction,
          radioValue === "2" ? "my_tasks" : "",
          filters
        )
      );
    }
  }, [radioValue, filters, selectedFunction]);
  useEffect(() => {
  if (aiGeneratedTasks?.tasks_json?.length > 0) {
    setGeneratedTasks(aiGeneratedTasks.tasks_json);
    setShowAiTaskGenerate(false);
    setAiTaskEdit(true);
  }
}, [aiGeneratedTasks]);

  // useEffect(() => {
  //   const bi_id = localStorage.getItem("bi_id");
  //   const product_id = localStorage.getItem("product_id");
  //   const selectedFunction = localStorage.getItem("selectedfunction");
  //   if (bi_id && product_id && selectedFunction) {
  //     dispatch(
  //       getWorkboardDetails(
  //         bi_id,
  //         product_id,
  //         selectedFunction,
  //         radioValue === "2" ? "my_tasks" : "",
  //         filters
  //       )
  //     );
  //   }
  // }, []);

  useEffect(() => {
    if (selectedBI) {
      setBIName(selectedBI.label);
    }
  }, [selectedBI]);

  useEffect(() => {
    if (getExistingFunctionsData && getExistingFunctionsData.new_fun) {
      setFunctionData(getExistingFunctionsData.new_fun);
      if (getExistingFunctionsData.new_fun.length > 0) {
        const selectedfun = localStorage.getItem("selectedfunction");
        const exists = getExistingFunctionsData.new_fun.some(
          (item) => item.id === selectedfun
        );

        const finalSelectedFunId = exists
          ? selectedfun
          : getExistingFunctionsData.new_fun[0].id;

        setSelectedFunction(finalSelectedFunId);
        setSelectedFunctionStyle(finalSelectedFunId);
        localStorage.setItem("selectedfunction", finalSelectedFunId);
      }
    }
  }, [getExistingFunctionsData]);

  useEffect(() => {
    if (
      getEmployeeDetails &&
      getEmployeeDetails.emp_data &&
      getEmployeeDetails.emp_data.length > 0
    ) {
      setEmpData(
        getEmployeeDetails.emp_data.map((obj) => {
          return {
            value: obj.id,
            label: obj.prop_name,
            icon: createImageFromInitials(
              30,
              obj.prop_name,
              getRandomColor(obj.prop_name)
            ),
          };
        })
      );
    }
  }, [getEmployeeDetails]);

  useEffect(() => {
    if (getMasterTasksPriorityAndStatusDetails) {
      const transformedStatusOptions =
        getMasterTasksPriorityAndStatusDetails.status_dt.map((status) => ({
          value: status,
          label: status,
        }));
      setStatusData(transformedStatusOptions);
      const transformedPriorityOptions =
        getMasterTasksPriorityAndStatusDetails.priority_dt.map((priority) => ({
          value: priority,
          label: priority,
        }));
      setPriorityData(transformedPriorityOptions);
      const transformedMilestoneOptions =
        getMasterTasksPriorityAndStatusDetails.milestone.map((mile) => ({
          value: mile.value,
          label: mile.label,
        }));
      setMileStonesData(transformedMilestoneOptions);
    }
  }, [getMasterTasksPriorityAndStatusDetails]);

  useEffect(() => {
    if (
      WorkboardData &&
      WorkboardData.functions &&
      WorkboardData.functions.length > 0 &&
      WorkboardData.functions[0].strategic_imperative
    ) {
      setImperativeData(WorkboardData.functions[0].strategic_imperative);
    } else {
      setImperativeData([]);
    }
  }, [WorkboardData]);

  useEffect(
    (isFunctionDataFetched) => {
      if (
        postStrategyFunctionDetails &&
        postStrategyFunctionDetails.response &&
        postStrategyFunctionDetails.stage_type === "task"
      ) {
        if (postStrategyFunctionDetails.action === "add") {
          postStrategyFunctionDetails?.response?.map((item) => {
            const updatedImpData = [...imparativeData];
            const newTask = {
              name: item.value,
              id: item.key,
              status: item.dt_status,
              due_date: item.due_date,
              assigned_to: item.assigned_to,
              priority: item.priority,
              progress: item.progress,
              description: item.description,
              collaberators: item.collaberators,
              sub_tasks: [],
            };
            updatedImpData[currentImperativeIndex] &&
              updatedImpData[currentImperativeIndex]?.milestones[
                currentMilestoneIndex
              ]?.tasks.push(newTask);
            setImperativeData(updatedImpData);
          });
          // window.location.reload();
        } else if (postStrategyFunctionDetails.action === "edit") {
          if (
            (biIdParams,
            productIdParams,
            taskIdParams,
            parentTaskIdParams,
            functionParams)
          ) {
            navigate("/workboard", { replace: true });
          } else {
            const updatedImpData = [...imparativeData];
            const existingTasks = updatedImpData[currentImperativeIndex]
              ?.milestones?.[currentMilestoneIndex]?.tasks?.[currentTaskIndex];
            if (!existingTasks) return;
            postStrategyFunctionDetails.response.map((item) => {
              updatedImpData[currentImperativeIndex].milestones[
                currentMilestoneIndex
              ].tasks[currentTaskIndex] = {
                ...existingTasks,
                name: item.value,
                status: item.dt_status,
                due_date: item.due_date,
                assigned_to: item.assigned_to,
                priority: item.priority,
                progress: item.progress,
                description: item.description,
                collaberators: item.collaberators,
                sub_tasks: item.sub_tasks,
              };
              setImperativeData(updatedImpData);
            });
          }
          // window.location.reload();
        } else if (postStrategyFunctionDetails.action === "delete") {
          postStrategyFunctionDetails.response.map((item) => {
            const updatedImpData = [...imparativeData];

            const milestone =
              updatedImpData[currentImperativeIndex]?.milestones[
                currentMilestoneIndex
              ];

            if (milestone?.tasks) {
              milestone.tasks = milestone.tasks.filter(
                (task) => task.id !== item.key
              );
            }

            setImperativeData(updatedImpData);
          });
        }
      }
      if (
        postStrategyFunctionDetails &&
        postStrategyFunctionDetails.response &&
        postStrategyFunctionDetails.stage_type === "sub_task"
      ) {

        if (postStrategyFunctionDetails.action === "add") {

          postStrategyFunctionDetails?.response?.map((item) => {
            const updatedImpData = [...imparativeData];

            const newSubTask = {
              name: item.value,
              id: item.key,
              status: item.dt_status,
              due_date: item.due_date,
              assigned_to: item.assigned_to,
              priority: item.priority,
              progress: item.progress,
              description: item.description,
              collaberators: item.collaberators,
             
            };

            updatedImpData[currentImperativeIndex] &&
              updatedImpData[currentImperativeIndex]?.milestones[
                currentMilestoneIndex
              ]?.tasks[currentParentTaskIndex]?.subtasks.push(newSubTask);

            setImperativeData(updatedImpData);
          });

        } else if (postStrategyFunctionDetails.action === "edit") {

          const updatedImpData = [...imparativeData];

          const existingSubTask = updatedImpData[currentImperativeIndex]
            ?.milestones?.[currentMilestoneIndex]?.tasks?.[currentParentTaskIndex]
            ?.subtasks?.[currentSubTaskIndex];
          if (!existingSubTask) return;

          postStrategyFunctionDetails.response.map((item) => {

            updatedImpData[currentImperativeIndex].milestones[
              currentMilestoneIndex
            ].tasks[currentParentTaskIndex].subtasks[currentSubTaskIndex] = {
              ...existingSubTask,
              name: item.value,
              status: item.dt_status,
              due_date: item.due_date,
              assigned_to: item.assigned_to,
              priority: item.priority,
              progress: item.progress,
              description: item.description,
              collaberators: item.collaberators,
            
            };

            setImperativeData(updatedImpData);
          });

        } else if (postStrategyFunctionDetails.action === "delete") {

          postStrategyFunctionDetails.response.map((item) => {

            const updatedImpData = [...imparativeData];

            const task =
              updatedImpData[currentImperativeIndex]?.milestones[
                currentMilestoneIndex
              ]?.tasks[currentParentTaskIndex];

            if (task?.subtasks) {
              task.subtasks = task.subtasks.filter(
                (subtask) => subtask.id !== item.key
              );
            }

            setImperativeData(updatedImpData);
          });
        }
      }
    },
    [isFunctionDataFetched, postStrategyFunctionDetails]
  );

  useEffect(() => {
    // Open all imperatives by default
    if (imparativeData) {
      imparativeData.forEach((item) => {
        item.isCollapsed = false;
      });
    }
    if (localStorage.getItem("bi_id") && localStorage.getItem("product_id")) {
      dispatch(
        getExistingFunctions(
          localStorage.getItem("bi_id"),
          localStorage.getItem("product_id"),
          true
        )
      );
    }
    dispatch(getEmployeeData(localStorage.getItem("bi_id")));
  }, []);

  useEffect(() => {
    if (selectedFunction) {
      if (localStorage.getItem("bi_id") && localStorage.getItem("product_id")) {
        dispatch(
          getMasterTaskPriorityAndStatusData(
            localStorage.getItem("bi_id"),
            localStorage.getItem("product_id"),
            selectedFunction
          )
        );
      }
    }
  }, [selectedFunction]);
  const handleClick = () => {
    navigate("/bitracker");
  };
  const handleBack = () => {
    navigate("/executionplan");
  };
  const handleDuplicateTaskClick = (id, task_title) => {
    setDuplicateTaskId(id);
    setDuplicateTaskName(task_title);
  };
  const handleDTPopupClose = () => {
    setShowDuplicateTaskPopup(false);
  };
  const handleDTPopupShow = () => {
    setShowDuplicateTaskPopup(true);
  };
  const openTaskNav = (
    task,
    breadcrumb,
    milesid,
    milestoneIndex,
    imperativeIndex,
    taskIndex,
    functionalgoal_id,
    subTaskIndex = null
  ) => {
    setCurrentTaskIndex(taskIndex);
    setIsSubTaskVisible(true);
    setCurrentImperativeIndex(imperativeIndex);
    setCurrentMilestoneIndex(milestoneIndex);
    if (subTaskIndex !== null) {
      setCurrentParentTaskIndex(taskIndex);
      setCurrentSubTaskIndex(subTaskIndex);
    } else {
      setCurrentTaskIndex(taskIndex);
      setCurrentParentTaskIndex(taskIndex);
    }
    if (task) {
      setIsNewTask(false);
      dispatch(getTaskDetails(task.id));
      setSelectedTaskId(task.id);
      setSubTaskId(task.id);
    } else {
      setSelectedTaskMilestoneId(milesid);
      setIsNewTask(true);
      setSelectedTaskId(false);
    }

    setBreadcrumbs(breadcrumb);
    setIsTaskSidebarOpen(true);
  };

  const closeTaskNav = () => {
    if (
      (biIdParams,
      productIdParams,
      taskIdParams,
      parentTaskIdParams,
      functionParams)
    ) {
      navigate("/workboard", { replace: true });
    }
    setHighlightedRowIndex(null);
    setIsTaskSidebarOpen(false);
  };

  const handleSelectFunction = (selectedfunction) => {
    setSelectedFunction(selectedfunction);
    localStorage.setItem("selectedfunction", selectedfunction);
    setSelectedFunctionStyle(selectedfunction);
    setSelectedTaskIds([]);

    const bi_id = localStorage.getItem("bi_id");
    const product_id = localStorage.getItem("product_id");

    // if (bi_id && product_id && selectedfunction) {
    //   dispatch(
    //     getWorkboardDetails(
    //       bi_id,
    //       product_id,
    //       selectedfunction,
    //       radioValue === "2" ? "my_tasks" : ""
    //     )
    //   );
    // }
  };

  const handleCollapseToggle = (impIndex) => {
    setImperativeData((prevImperativeData) => {
      const newList = [...prevImperativeData];
      newList[impIndex].isCollapsed = !newList[impIndex].isCollapsed; // Toggle the collapse state for the specific function
      return newList;
    });
  };

  const handleCollapseToggleMilestone = (milestoneIndex) => {
    setCollapsedItems((prevCollapsedItems) => ({
      ...prevCollapsedItems,
      [milestoneIndex]: !prevCollapsedItems[milestoneIndex],
    }));
  };

  const handleTaskDataChange = (
    imperativeIndex,
    milestoneIndex,
    taskIndex,
    field,
    data
  ) => {
    const updatedImpData = [...imparativeData];
    updatedImpData[imperativeIndex].milestones[milestoneIndex].tasks[taskIndex][
      field
    ] = data;
    setImperativeData(updatedImpData);
    setTaskIndex(taskIndex);
  };
  const handleToggleTaskEditing = (
    imperativeIndex,
    milestoneIndex,
    taskIndex,
    editing
  ) => {
    const updatedImpData = [...imparativeData];
    updatedImpData[imperativeIndex].milestones[milestoneIndex].tasks[
      taskIndex
    ].isEditing = editing;
    setImperativeData(updatedImpData);
  };

  const handleAddNewTask = (imperativeIndex, milestoneIndex, milestoneId) => {
    setCurrentImperativeIndex(imperativeIndex);
    setCurrentMilestoneIndex(milestoneIndex);
    let data = [
      {
        parent_task_id: milestoneId,
        task_name: newTaskName,
        assigned_to: [],
        due_date: "",
        start_date:"",
        status: "Open",
        priority: "High",
        progress: 0,
        description: "",
        collaberators: [],
        is_active: true,
        task_id: false,
      },
    ];
    dispatch(postStrategyFunctions(data, "task", false, false, false, true));

    // Clear the new task inputs and hide the input section
    setNewTaskName("");
    setNewTaskDueDate(null);
    const updatedShowNewTaskInput = [...showNewTaskInput];
    updatedShowNewTaskInput[milestoneId] = false;
    setShowNewTaskInput(updatedShowNewTaskInput);
  };

  const handleStepClick = (stepIndex) => {
    // setCurrentStep(stepIndex);
  };

  const handleTaskDelete = () => {
    Alert.warning({
      title:
        "Deleting a Functional Goal or Milestone or Parent Task will also delete all of its milestones and tasks and sub-tasks.",
      text: "Are you sure you want to delete?",
      icon: "warning",
      showCancelButton: true,
      preConfirm: (isConfirm) => {
        if (isConfirm) {
          let data = [
            {
              task_id: selectedTaskId,
              is_active: false,
            },
          ];
          dispatch(
            postStrategyFunctions(data, "task", false, false, false, true)
          );
          closeTaskNav();
          dispatch(resetExceptionError());
        } else {
        }
      },
    });
  };

  const handleChevronClick = (
    milestoneItem,
    breadcrumb,
    impIndex,
    milestoneIndex,
    imperativeName
  ) => {
    const userperm = milestoneItem?.user_permission;
    const user_duedate_perm = milestoneItem?.due_date_perm;
    setUserDueDatePermission(user_duedate_perm);
    if (userperm === "write") {
      setUserPermission(userperm);
    } else if (userperm === "read") {
      setUserPermission(userperm);
    }
    setMilestoneData(milestoneItem);
    setBreadcrumbs(breadcrumb);
    setCurrentImperativeIndex(impIndex);
    setCurrentMilestoneIndex(milestoneIndex);
    setImperativeName(imperativeName);
  };

  const handleMilestoneEdit = (
    functionIndex,
    impIndex,
    milestoneIndex,
    milestone_data,
    updatedAssignedData
  ) => {
    const updatedImpData = [...imparativeData];

    const existingMilestone =
      updatedImpData[impIndex].milestones[milestoneIndex];
    updatedImpData[impIndex].milestones[milestoneIndex] = {
      ...existingMilestone,
      name: milestone_data[0].milestone,
      status: milestone_data[0].status,
      due_date: milestone_data[0].due_date,
      start_date:milestone_data[0].start_date,
      priority: milestone_data[0].priority,
      assigned_to: updatedAssignedData,
      progress: milestone_data[0].progress,
      description: milestone_data[0].description,
      collaberators: milestone_data[0].collaberators,
    };
    setImperativeData(updatedImpData);
    dispatch(
      postStrategyFunctions(milestone_data, "milestone", false, false, true)
    );
  };

  const handleMilestoneDelete = (
    functionIndex,
    simpIndex,
    milestoneIndex,
    milestoneId
  ) => {
    Alert.warning({
      title:
        "Deleting a Functional Goal or Milestone or Parent Task will also delete all of its milestones and tasks and sub-tasks.",
      text: "Are you sure you want to delete?",
      icon: "warning",
      showCancelButton: true,
      preConfirm: (isConfirm) => {
        if (isConfirm) {
          const updatedImpData = [...imparativeData];
          updatedImpData[simpIndex].milestones.splice(milestoneIndex, 1);
          setImperativeData(updatedImpData);
          let data = [
            {
              milestone_id: milestoneId,
              is_active: false,
            },
          ];
          dispatch(
            postStrategyFunctions(data, "milestone", false, false, true)
          );
          dispatch(resetExceptionError());
        } else {
        }
      },
    });
  };

  // Styled to match the Filters pill button (.wb-filter-btn)
  const customStyles = {
    control: (base) => ({
      ...base,
      height: 30,
      minHeight: 30,
      zIndex: 3,
      border: "1px solid var(--button-primary-color)",
      borderRadius: 20,
      backgroundColor: "#fff",
      boxShadow: "none",
      cursor: "pointer",
      "&:hover": {
        borderColor: "var(--button-primary-color)",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: 30,
      padding: "0 2px 0 10px",
      fontWeight: 500,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "var(--button-primary-color)",
      fontWeight: 500,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "var(--button-primary-color)",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: 30,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0 8px 0 2px",
      color: "var(--button-primary-color)",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // or any high number
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  // Borderless react-select styling used only inside the workboard filter bar
  // (customStylesTable above is shared with the bulk edit modal)
  const customStylesFilterBar = {
    control: (base) => ({
      ...base,
      minHeight: "26px",
      height: "26px",
      minWidth: "72px",
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
      cursor: "pointer",
      fontSize: "13px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 2px",
      fontWeight: "600",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#101828",
      fontWeight: "600",
    }),
    input: (base) => ({ ...base, margin: "0px", padding: "0px" }),
    indicatorsContainer: (base) => ({ ...base, height: "26px" }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "0 2px",
      color: "#98a2b3",
      "&:hover": { color: "#0A5F59" },
    }),
    menu: (base) => ({ ...base, zIndex: 9999, minWidth: "140px" }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base) => ({ ...base, fontSize: "13px" }),
  };

  const workboardHeadStyle = {
    fontSize: "14px",
    fontWeight: "600",
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: "#748b82",
  };

  const handletaskFilterChange = (e) => {
    setRadioValue(e.value);
    localStorage.setItem("workboard_filter", e.value);
  };

  const handleCSVButtonClick = (toolvalue) => {
    dispatch(
      getExportWorkboardCsvfile(
        localStorage.getItem("bi_id"),
        localStorage.getItem("product_id"),
        toolvalue
      )
    );
  };

  const statusOptions = [
    { value: "Open", label: "Open" },
    { value: "Working", label: "Working" },
    { value: "Pending Review", label: "Pending Review" },
    { value: "Overdue", label: "Overdue" },
    { value: "Template", label: "Template" },
    { value: "Completed", label: "Completed" },
    { value: "Cancelled", label: "Cancelled" },
  ];

  const priorityOptions = [
    { value: "Low", label: "Low" },
    { value: "Medium", label: "Medium" },
    { value: "High", label: "High" },
    { value: "Urgent", label: "Urgent" },
  ];
  const progressOptions = [
    { value: "0", label: "0" },
    { value: "20", label: "20" },
    { value: "40", label: "40" },
    { value: "60", label: "60" },
    { value: "80", label: "80" },
    { value: "100", label: "100" },
  ];

  const customStylesTable = {
    control: (base, state) => ({
      ...base,
      height: 30,
      minHeight: 30,
      backgroundColor: state.hasValue ? "#e6f4ea" : "#fff", // ✅ selected bg
      borderColor: state.hasValue ? "#28a745" : base.borderColor,
      boxShadow: "none",
      "&:hover": {
        borderColor: state.hasValue ? "#28a745" : base.borderColor,
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: 30,
      padding: "0 8px",
      fontWeight: "200",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: 30,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
      minWidth: "140px",
      whiteSpace: "no-wrap",
    }),
  };

  const [overdueTasks, setOverdueTasks] = useState([]);
  const [tasksCount, setTasksCount] = useState([0, 0, 0]);
  const [showPopup, setShowPopup] = useState(false);

  const shouldShowPopupToday = () => {
    const lastShown = localStorage.getItem("overdue_popup_last_shown");
    const today = new Date().toISOString().split("T")[0];
    return lastShown !== today;
  };

  const markPopupShownToday = () => {
    const today = new Date().toISOString().split("T")[0];
    localStorage.setItem("overdue_popup_last_shown", today);
  };

  useEffect(()=> {
    if (OverdueTaskData){
      const tasks = OverdueTaskData?.tasks || [];
      setOverdueTasks(tasks);
      const count = OverdueTaskData?.count || [0, 0, 0];
      setTasksCount(count);

      if (tasks.length > 0 && shouldShowPopupToday()) {
        setShowPopup(true);
      }
    }

  } ,[OverdueTaskData]);

  useEffect(() => {
    const timer = setTimeout(() => {

    const lastFetchDate = localStorage.getItem("overdue_popup_last_shown");
    const today = new Date().toISOString().split("T")[0];

    if (lastFetchDate === today) {
      console.log("Skipping API call — already fetched today");
      return;
    }

    if (localStorage.getItem("product_id")) {

      dispatch(getOverdueTaskDetails())

    }
    }, 2500); //   ⏳ Wait 1.5 seconds

    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    markPopupShownToday();
    setShowPopup(false);
  };

  const label = (count, text) =>
    count === 1 ? `task ${text}` : `tasks ${text}`;

  const handleSelectTaskRow = (taskId, parentMilestoneId, taskName, type = "task",subtasks=[]) => {
    setSelectedTaskIds((prev) => {
      const exists = prev.some(item => item.id === taskId);
      if (exists) {
        return prev.filter((item) => item.id !== taskId);
      } else {
        return [...prev, {
          id: taskId,
          parent_task_id: parentMilestoneId,
          task_name: taskName,
          task_type: type,
          has_subtasks: type === "task" && subtasks?.length > 0,
        }];
      }
    });
  };

  const isMilestoneFullySelected = (milestoneItem) => {
    if (!milestoneItem?.tasks || milestoneItem.tasks.length === 0) return false;
   const milestoneTasks = milestoneItem.tasks.flatMap((task) => [
    ...(task.can_select ? [{ id: task.id }] : []),
    ...(task.subtasks || [])
      .filter((subtask) => subtask.can_select)
      .map((subtask) => ({
        id: subtask.id,
      })),
  ]);
    if (milestoneTasks.length === 0) return false;
    return milestoneTasks.every((t) => selectedTaskIds.some((item) => item.id === t.id));
  };
  const handleSelectMilestoneTasks = (milestoneItem) => {
    if (!milestoneItem || !milestoneItem.tasks) return;

    const milestoneTasks = milestoneItem.tasks.flatMap((task) => {
     const taskItem = task.can_select
      ? [{
          id: task.id,
          parent_task_id: milestoneItem.id,
          task_name: task.name,
          task_type: "task",
          has_subtasks: (task.subtasks || []).length > 0,
        },]
      : [];

    const subTaskItems = (task.subtasks || [])
      .filter((subtask) => subtask.can_select)
      .map((subtask) => ({
        id: subtask.id,
        parent_task_id: task.id,
        task_name: subtask.name,
        task_type: "sub_task",
      }));

      return [...taskItem, ...subTaskItems];
    });

    const areAllCurrentMilestoneTasksSelected =
      milestoneTasks.length > 0 &&
      milestoneTasks.every((item) =>
        selectedTaskIds.some((selected) => selected.id === item.id)
      );

    setSelectedTaskIds((prev) => {
      if (areAllCurrentMilestoneTasksSelected) {
        return prev.filter(
          (item) => !milestoneTasks.some((task) => task.id === item.id)
        );
      } else {
        const uniquePrev = prev.filter(
          (item) => !milestoneTasks.some((task) => task.id === item.id)
        );

        return [...uniquePrev, ...milestoneTasks];
      }
    });
  };
  const handleBulkSubmitSave = () => {
    if (!selectedTaskIds || selectedTaskIds.length === 0) return;

    const taskIds = selectedTaskIds.map((item) => item.id || item);
    const fieldsToUpdate = {};
    const selectedFunctionId = selectedFunction || localStorage.getItem("selectedfunction");
    if (bulkFields.assigned_to)
      fieldsToUpdate.assigned_to = bulkFields.assigned_to;
    if (bulkFields.priority)
      fieldsToUpdate.priority = bulkFields.priority;
    if (bulkFields.status)      
      fieldsToUpdate.status = bulkFields.status;
    if (bulkFields.start_date)
      fieldsToUpdate.start_date = bulkFields.start_date;
    if(bulkFields.due_date)
      fieldsToUpdate.due_date=bulkFields.due_date;
    if (bulkFields.progress !== null && bulkFields.progress !== undefined && bulkFields.progress !== "") {
      fieldsToUpdate.progress = Number(bulkFields.progress);
    }
    if (Object.keys(fieldsToUpdate).length === 0) {
      setShowBulkModal(false);
      return;
    }
    dispatch(postBulkTaskUpdate(taskIds, fieldsToUpdate,selectedFunctionId));
    setShowBulkModal(false);
    setCurrentStep(0);
    setSelectedTaskIds([]);
    setBulkFields({
      assigned_to: null, priority: null,status:null, start_date: null, progress: null,due_date:null
    });
  };
  const handleBulkProgressClick = (stepIndex) => {
    const calculatedPercentage = stepIndex * 20;
    setBulkFields(prev => ({
      ...prev,
      progress: calculatedPercentage
    }));

    setCurrentStep(stepIndex);
  };

  const hasDependentSubtasks = selectedTaskIds.some(
  (item) =>
    item.task_type === "task" &&item.has_subtasks
);
  // Read a stored "YYYY-MM-DD" as local midnight so the picker never shows the previous day
  const toPickerDate = (value) => (value ? new Date(`${value}T00:00:00`) : null);

  const hasDueRange = Boolean(filters.due_from || filters.due_to);

  const dueRangeLabel =
    filters.due_from && filters.due_to
      ? `${filters.due_from} ~ ${filters.due_to}`
      : filters.due_from || filters.due_to || "";

  const content = (
    <div>
      {/* {showPopup && ( */}
      <Dialog
        open={showPopup}
        // onClose={closePopup}
        maxWidth={"md"}
        fullWidth={false}
        PaperProps={{
          sx: { borderRadius: 4 }, // 4 = 32px / change as you like
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "var(--sub-menu-bg-color)",
            display: "flex",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              width: "100%",
              display:'flex',
              justifyContent:'space-between',
              alignItems:'center'

            }}
          >
            <div
              style={{
                fontWeight: 500,
                padding: "10px 30px",
                marginRight: "20px",
              }}
            >
              You have{" "}
              {tasksCount[0] > 0 && (
                <>
                  <strong
                    style={{
                      backgroundColor: "#f4fdf7ff",
                      padding: "4px 8px",
                      borderRadius: "5px",
                    }}
                  >
                    {tasksCount[0]}
                  </strong>{" "}
                  {label(tasksCount[0], "overdue")}
                </>
              )}
              {tasksCount[0] > 0 &&
                (tasksCount[1] > 0 || tasksCount[2] > 0) &&
                ", "}
              {tasksCount[1] > 0 && (
                <>
                  <strong
                    style={{
                      backgroundColor: "#f4fdf7ff",
                      padding: "4px 8px",
                      borderRadius: "5px",
                    }}
                  >
                    {tasksCount[1]}
                  </strong>{" "}
                  due today
                </>
              )}
              {tasksCount[1] > 0 && tasksCount[2] > 0 && ", and "}
              {tasksCount[2] > 0 && (
                <>
                  <strong
                    style={{
                      backgroundColor: "#f4fdf7ff",
                      padding: "4px 8px",
                      borderRadius: "5px",
                    }}
                  >
                    {tasksCount[2]}
                  </strong>{" "}
                  nearing their deadline
                </>
              )}
              . Please review and take action.
            </div>

            <div>
              <button
                style={{
                  border: "none",
                  width: "40px",
                  height: "40px",
                  borderRadius: "20px",
                  backgroundColor: "white",
                  fontSize: "24px",
                }}
                onClick={closePopup}
              >
                &times;
              </button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            borderRadius: "30px",
          }}
        >
          <div
            style={{
              padding: "0 20px",
              minWidth: "800px",
              width: "100%",
              display: "flex",
              // alignItems: "center",
              minHeight: "30vh",
              maxHeight: "60vh",
        
            }}
          >
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th
                style={{
                borderBottom: "1px solid #ccc",
                padding: "8px",
                textAlign: "left",
                width: "30%",//"25%",//"30%",
                fontWeight: "var(--heading-font-weight)"
              }}>Business Initiative
              </th>
                  <th
                    style={{
                      borderBottom: "1px solid #ccc",
                      padding: "8px",
                      textAlign: "left",
                      width: "50%",// 70
                      fontWeight: "var(--heading-font-weight)"                   
                       }}
                  >
                    Task
                  </th>
                  <th
                    style={{
                      borderBottom: "1px solid #ccc",
                      padding: "8px",
                      textAlign: "right",//"center",
                      width:"20%",
                      fontWeight: "var(--heading-font-weight)"
                    }}
                  >
                    Deadline Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {overdueTasks.map((task) => (
                  <tr key={task.name}>

                      <td
                  style={{
                    borderBottom: "1px solid #eee",
                    padding: "8px",
                    textAlign: "left",
                    // fontSize: "13px",
                   // color: "#666" // Lighter color to distinguish it from Task Subject
                  }}
                  >{task.bi_name } 
                  </td>
                    <td
                      style={{
                        borderBottom: "1px solid #eee",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      {task.subject}
                    </td>
                    <td
                      style={{
                        borderBottom: "1px solid #eee",
                        padding: "8px",
                         textAlign: "right",
                        color:
                          task.type === "overdue"
                            ? "#D32F2F"
                            : task.type === "today"
                            ? "#F9A825"
                            : task.type === "due"
                            ? "#2E7D32"
                            : "black",
                      }}
                    >
                      {task.days_overdue}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </DialogContent>
      </Dialog>
      {/* )} */}
      <div
        style={{
          position: "sticky",
          marginTop: "0px",
          width: "100%",
          top: "0px",
          zIndex: 1,
          backgroundColor: "white",
        }}
      >
        <div style={{ width: "100%" }}>
          <div className="d-flex functiondata" style={{ alignItems: "center" }}>
            <div className="workboard-filter">
              <Select
                required
                styles={customStyles}
                className="select-filter"
                placeholder={
                  <span style={{ fontSize: "var(--sub-heading-font-size)" }}>
                    Select
                  </span>
                }
                options={filters_data}
                menuPortalTarget={document.body}
                onChange={(e) => handletaskFilterChange(e)}
                isSearchable={true}
                value={filters_data.find(
                  (option) => option.value === radioValue
                )}
                getOptionLabel={(e) => (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img alt="" src={e.icon} />
                    <span
                      style={{
                        marginLeft: 5,
                        fontSize: "var(--sub-heading-font-size)",
                      }}
                    >
                      {e.name}
                    </span>
                  </div>
                )}
              />
            </div>
            <button
              type="button"
              className={`wb-filter-btn${showFilters ? " is-open" : ""}`}
              onClick={() => setShowFilters((prev) => !prev)}
              aria-expanded={showFilters}
              aria-controls="wb-filter-bar"
              title={showFilters ? "Hide filters" : "Show filters"}
            >
              <BsFilter size={15} />
              <span>Filters</span>
              {activeFilterCount > 0 && (
                <span className="wb-filter-btn-badge">{activeFilterCount}</span>
              )}
              <BsChevronDown
                size={12}
                className={`wb-filter-btn-chevron${showFilters ? " is-open" : ""}`}
              />
            </button>
            <span className="wb-toolbar-divider" />
            {/* {biName && functionData && functionData.length > 0 && (
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
              >
                <div
                  className="workboard-chevron-down"
                  style={{
                    backgroundColor: isDropdownVisible ? "#f8f8f8" : "",
                  }}
                >
                  <button onClick={() => toggleDropdown()}>
                    <i className="bi bi-chevron-down"></i>
                  </button>
                </div>
              </OverlayTrigger>
            )} */}

            {functionData &&
              functionData.length > 0 &&
              functionData.map((funItem, funIndex) => (
                <p
                  key={funItem.id}
                  className="function-button"
                  style={{
                    // backgroundColor:
                    //   funIndex % 3 === 0
                    //     ? "#8746f1"
                    //     : funIndex % 3 === 1
                    //     ? "#51a5f2"
                    //     : "#df58c9",
                    backgroundColor:
                      selectedFunction === funItem.id
                        ? "#0A5F59"
                        : "transparent",
                    color: selectedFunction === funItem.id ? "white" : "black",
                    border:
                      selectedFunction === funItem.id
                        ? "none"
                        : "1px solid lightgrey",
                    padding: "4px 12px",
                    borderRadius: "20px",
                    // boxShadow:
                    //   selectedFunction === funItem.id
                    //     ? "0px 0px 5px 5px #D0BFFF"
                    //     : "",
                    fontWeight: selectedFunction === funItem.id ? "600" : "400",
                    fontSize: "var(--sub-heading-font-size)",
                    marginBottom: "0",
                    cursor: "pointer",
                  }}
                  onClick={(e) => handleSelectFunction(funItem.id, funIndex)}
                >
                  {funItem.name}
                </p>
              ))}
          </div>
          {/* <br /> */}
          <table
            style={{
              width: "100%",
              tableLayout: "fixed",
              borderCollapse: "collapse",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            {/* table-layout:fixed reads column widths from the first row, so with the
                filter bar as row 1 the widths have to live in a colgroup to keep the
                headings aligned with the milestone/task columns below */}
            <colgroup>
              <col style={{ width: "58%" }} />
              <col style={{ width: "6%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "8%" }} />
              <col style={{ width: "8%" }} />
              <col style={{ width: "8%" }} />
            </colgroup>
            <thead>
              <tr className={showFilters ? "" : "wb-filter-row-hidden"}>
                <th colSpan={6} className="wb-filter-cell">
                  <div className="wb-filter-bar" id="wb-filter-bar">
                    <div className="wb-filter-search">
                      <BsSearch size={14} />
                      <input
                        type="text"
                        aria-label="Search milestones, tasks, or owners"
                        value={filters.milestone}
                        placeholder="Search milestones, tasks, or owners..."
                        onChange={(e) =>
                          handleFilterChange("milestone", e.target.value)
                        }
                      />
                    </div>

                    <div className="wb-filter-field">
                      <label htmlFor="wb-filter-owner" className="wb-filter-label">
                        Owner:
                      </label>
                      <Select
                        inputId="wb-filter-owner"
                        options={withAllOption(empData)}
                        value={
                          withAllOption(empData).find(
                            (opt) => opt.value === filters.owner
                          ) || null
                        }
                        onChange={(selected) =>
                          handleFilterChange("owner", selected?.value || "")
                        }
                        styles={customStylesFilterBar}
                        menuPortalTarget={document.body}
                        isClearable={false}
                        isSearchable={true}
                        placeholder=""
                      />
                    </div>

                    <div className="wb-filter-field">
                      <span className="wb-filter-label">Due Date:</span>
                      <OverlayTrigger
                      trigger="click"
                      rootClose="true"
                      placement="bottom"
                      overlay={
                        <Popover id="due-range-filter-popover" className="due-range-popover">
                          <div style={{ padding: "10px", overflow: "visible", display: "flex", flexDirection: "row", gap: "10px" }}>
                            {/* <div style={{ fontWeight: "600", fontSize: "13px", marginBottom: "10px" }}>
                              Filter by Due Date
                            </div> */}
                            <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                            <div><label style={{ display: "block", fontSize: "12px", marginBottom: "4px" }}>
                              Due From
                            </label>
                            <DatePicker
                              wrapperClassName="w-100"
                              dateFormat="yyyy-MM-dd"
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              maxDate={toPickerDate(filters.due_to) || undefined}
                              selected={toPickerDate(filters.due_from)}
                              onChange={(date) =>
                                handleFilterChange(
                                  "due_from",
                                  date
                                    ? new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                    : ""
                                )
                              }
                              customInput={
                                <input
                                  readOnly
                                  placeholder="YYYY-MM-DD"
                                  style={{
                                    width: "100%", height: "30px", padding: "0 8px", border: `1px solid ${filters.due_from ? "#28a745" : "#ccc"}`, borderRadius: "4px", fontSize: "14px", background: filters.due_from ? "#e8f5e9" : "#fff", boxSizing: "border-box", outline: "none",
                                  }}
                                />
                              }
                            /></div>
                            <div> 
                            <label style={{ display: "block", fontSize: "12px", marginBottom: "4px" }}>
                              Due To
                            </label>
                            <DatePicker
                              wrapperClassName="w-100"
                              dateFormat="yyyy-MM-dd"
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              minDate={toPickerDate(filters.due_from) || undefined}
                              selected={toPickerDate(filters.due_to)}
                              onChange={(date) =>
                                handleFilterChange(
                                  "due_to",
                                  date
                                    ? new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                    : ""
                                )
                              }
                              customInput={
                                <input
                                  readOnly
                                  placeholder="YYYY-MM-DD"
                                  style={{
                                    width: "100%", height: "30px", padding: "0 8px", border: `1px solid ${filters.due_to ? "#28a745" : "#ccc"}`, borderRadius: "4px", fontSize: "14px", background: filters.due_to ? "#e8f5e9" : "#fff", boxSizing: "border-box", outline: "none",
                                  }}
                                />
                              }
                            />
                            </div>
                            </div>
                            {hasDueRange && (
                              <button
                                type="button"
                                onClick={() => {
                                  handleFilterChange("due_from", "");
                                  handleFilterChange("due_to", "");
                                }}
                                style={{
                                  marginTop: "12px", border: "none", background: "none", color: "#0A5F59", fontSize: "24px", fontWeight: "600", padding: "5px", cursor: "pointer",
                                }}
                              >
                                &times;
                              </button>
                            )}
                          </div>
                        </Popover>
                      }
                    >
                      {({ ref, ...triggerProps }) => (
                        <button
                          type="button"
                          ref={ref}
                          {...triggerProps}
                          aria-label="Filter by due date"
                          title={dueRangeLabel || "Any"}
                          className={`wb-filter-value${
                            hasDueRange ? " is-active" : ""
                          }`}
                        >
                          {dueRangeLabel || "Any"}
                          <SlCalender size={14} />
                        </button>
                      )}
                    </OverlayTrigger>
                    </div>

                    <div className="wb-filter-field">
                      <label htmlFor="wb-filter-progress" className="wb-filter-label">
                        Progress:
                      </label>
                      <Select
                        inputId="wb-filter-progress"
                        options={withAllOption(progressOptions)}
                        value={
                          withAllOption(progressOptions).find(
                            (opt) => opt.value === filters.progress
                          ) || null
                        }
                        onChange={(selected) =>
                          handleFilterChange("progress", selected?.value || "")
                        }
                        styles={customStylesFilterBar}
                        menuPortalTarget={document.body}
                        isClearable={false}
                        placeholder=""
                      />
                    </div>
                    <div className="wb-filter-field">
                      <label htmlFor="wb-filter-status" className="wb-filter-label">
                        Status:
                      </label>
                      <Select
                        inputId="wb-filter-status"
                        options={withAllOption(statusOptions)}
                        value={
                          withAllOption(statusOptions).find(
                            (opt) => opt.value === filters.status
                          ) || null
                        }
                        onChange={(selected) =>
                          handleFilterChange("status", selected?.value || "")
                        }
                        styles={customStylesFilterBar}
                        menuPortalTarget={document.body}
                        isClearable={false}
                        placeholder=""
                      />
                    </div>
                    <div className="wb-filter-field">
                      <label htmlFor="wb-filter-priority" className="wb-filter-label">
                        Priority:
                      </label>
                      <Select
                        inputId="wb-filter-priority"
                        options={withAllOption(priorityOptions)}
                        value={
                          withAllOption(priorityOptions).find(
                            (opt) => opt.value === filters.priority
                          ) || null
                        }
                        onChange={(selected) =>
                          handleFilterChange("priority", selected?.value || "")
                        }
                        styles={customStylesFilterBar}
                        menuPortalTarget={document.body}
                        isClearable={false}
                        placeholder=""
                      />
                    </div>

                    <button
                      type="button"
                      className="wb-filter-clear"
                      onClick={clearFilters}
                    >
                      &times; Clear
                    </button>
                  </div>
                </th>
              </tr>
              <tr>
                <th style={{ ...workboardHeadStyle, textAlign: "left", width: "60%" }}>
                  Milestones and Tasks
                </th>
                <th style={{ ...workboardHeadStyle, textAlign: "center", width: "6%" }}>
                  Owners
                </th>
                <th style={{ ...workboardHeadStyle, textAlign: "center", width: "10%", whiteSpace: "nowrap" }}>
                  Due Date
                </th>
                <th style={{ ...workboardHeadStyle, textAlign: "center", width: "8%" }}>
                  Progress
                </th>
                <th style={{ ...workboardHeadStyle, textAlign: "left", width: "8%" }}>
                  Status
                </th>
                <th style={{ ...workboardHeadStyle, textAlign: "left", width: "8%" }}>
                  Priority
                </th>
              </tr>
            </thead>
          </table>
        </div>
        {isBulkEditMode && (
          <div
            style={{
              position: "sticky",
              top: "0px",
              zIndex: 1000,
              width: "100%",
              height: "30px",
              padding: "0px 8px",
              background: "#C9DEDA",
              color: "#245B55",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              fontSize: "11px",
              fontWeight: "500",
              boxSizing: "border-box",
              position: "relative",
              borderRadius: "10px"
            }}
          >
            <div style={{ display: "flex", color: "#245B55", alignItems: "center", gap: "6px" }}>
              <BiEditAlt size={14} />
              <span style={{fontWeight: "var(--heading-font-weight"}}>Bulk edit mode active</span>
              <span
                style={{
                  opacity: 0.5,
                  margin: "0 2px",
                }}
              >
                |
              </span>

              <span
                style={{ opacity: 0.75, color: "#245B55" }}
              >
                <span style={{fontWeight: "var(--heading-font-weight"}}>
                  {selectedTaskIds.length}{" "}
                  {selectedTaskIds.length === 1 ? "task" : "tasks"} selected
                </span>
              </span>
            </div>
              <div
              style={{ position: "absolute", left: "50%", transform: "translateX(-50%)", fontSize: "11px", color: "red", fontWeight: "500", whiteSpace: "nowrap", }}
            >
              <span style={{fontWeight: "var(--heading-font-weight"}}>Note:</span> Bulk Edit mode active — limited functionality.Click “Exit Bulk Edit” to exit.
            </div>
            
            <div
              style={{ display: "flex", alignItems: "center", gap: "6px", }}
            >
              {selectedTaskIds.length > 0 && (
                <Button
                  type="button"
                  onClick={() => {
                    setCurrentStep(0);
                    setShowBulkModal(true);
                  }}
                  style={{
                    height: "21px",
                    padding: "0 10px",
                    backgroundColor: "#245B55",
                    border: "1px solid #245B55",
                    color: "#FFFFFF",
                    fontSize: "10px",
                    fontWeight: "500",
                    borderRadius: "3px",
                  }}
                >
                  Update
                </Button>
              )}

              {selectedTaskIds.length > 0 && (
                <Button
                  type="button"
                  onClick={() => setSelectedTaskIds([])}
                  style={{
                    height: "21px",
                    padding: "0 9px",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #B8C9C6",
                    color: "#374151",
                    fontSize: "10px",
                    borderRadius: "3px",
                    cursor: "pointer",
                  }}
                >
                  Deselect all
                </Button>
              )}
            </div>
          </div>
        )}

      </div>
      <motion.div
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      >
        {functionData &&
        functionData.length > 0 &&
        imparativeData &&
        imparativeData.length > 0 ? (
          imparativeData.map((impItem, impIndex) => (
            <div>
              <div className="d-flex align-items-center">
                <img
                  src={Arrow}
                  width={"24px"}
                  style={{
                    cursor: "pointer",
                    transition: "transform 0.3s ease",
                    transform: impItem.isCollapsed
                      ? "rotate(180deg)"
                      : "rotate(0)",
                  }}
                  onClick={() => handleCollapseToggle(impIndex)}
                />
                <button
                  style={{
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    padding: "2px 8px 4px 8px",
                    marginLeft: "8px",
                    fontSize: "var(--sub-heading-font-size)",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  className={`color${(impIndex % 3) + 1}`}
                  type="button"
                  title={impItem.name}
                  onClick={() => handleCollapseToggle(impIndex)}
                >
                  <span
                    style={{
                      maxWidth: "800px",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      display: "inline-block",
                    }}
                  >
                    {impItem.name}
                  </span>
                </button>

                <div>
                  {impItem.assigned_to.length > 0 &&
                  impItem.assigned_to.find((item) => item.is_active) ? (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip
                          id={`tooltip-${
                            impItem.assigned_to.find((item) => item.is_active)
                              .label
                          }`}
                        >
                          {
                            impItem.assigned_to.find((item) => item.is_active)
                              .label
                          }
                        </Tooltip>
                      }
                      >
                        <div style={{
                          position: "relative",
                          display: "inline-block",
                          // margin: "10px",
                        }}>
                          <img
                        style={{ margin: "10px" }}
                        alt=""
                        src={createImageFromInitials(
                          30,
                          impItem.assigned_to.find((item) => item.is_active)
                            .label,
                          getRandomColor(
                            impItem.assigned_to.find((item) => item.is_active)
                              .label
                          )
                        )}
                      />
                          {(impItem.assigned_to.find((item) => item.is_active)?.status ===
                            "Inactive" ||impItem.assigned_to.find((item) => item.is_active)?.bi_mapping===false)&&(
                              <TiDelete
                                size={14}
                                style={{
                                  position: "absolute",
                                  bottom: "10px",
                                  right: "10px",
                                  background: "#fff",
                                  borderRadius: "50%",
                                  color: "#DC2626",
                                  padding: "1px",
                                }}
                              />
                            )}
                        </div>

                      </OverlayTrigger>
                  ) : (
                    <img alt="" src={UserProfile} style={{ margin: "10px" }} />
                  )}
                </div>
                <DisabledGoalSelector
                  selectedGoals={
                    impItem &&
                    impItem.goals_dt &&
                    impItem.goals_dt.filter((goal) => goal.is_active)
                  }
                  options={impItem.goals_dt}
                />
              </div>

              <div
                className={`collapse ${impItem.isCollapsed ? "" : "show"}`}
                // style={{ paddingLeft: "22px" }}
              >
                <div className="goals-table">
                  <table className="goal-table-data">
                    {impItem.milestones.map((milestoneItem, milestoneIndex) => (
                      <>
                        <tbody>
                          <tr
                            className="milestoneContainer"
                            key={milestoneIndex}
                            style={{
                              textAlign: "left",
                              backgroundColor:
                                highlightedRowIndex === milestoneItem.id
                                  ? "#D9F6E4"
                                  : "rgb(255, 255, 255)",
                              width: "100%",
                            }}
                          >
                            <td style={{ width: "60%" }}>
                              <div
                                key={milestoneIndex}
                                style={{
                                  textAlign: "left",
                                  padding: "6px 0px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flex: "1 1 auto",
                                    minWidth: 0,
                                    overflow: "hidden",
                                  }}
                                >
                                  <img
                                    src={ArrowSIMP}
                                    width={"24px"}
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "10px",
                                      transition: "transform 0.3s ease",
                                      transform: collapsedItems[
                                        milestoneItem.id
                                      ]
                                        ? "rotate(180deg)"
                                        : "rotate(0)",
                                    }}
                                    onClick={() =>
                                      handleCollapseToggleMilestone(
                                        milestoneItem.id
                                      )
                                    }
                                  />
                                  <span
                                    style={{
                                      paddingLeft: "5px",
                                      minWidth: 0,
                                      overflow: "hidden",
                                    }}
                                  >
                                    <button
                                      className="workboard-text-ellipsis"
                                      style={{
                                        border: "none",
                                        backgroundColor: "transparent",
                                      }}
                                      title={milestoneItem.name}
                                      type="button"
                                      onClick={() =>
                                        handleCollapseToggleMilestone(
                                          milestoneItem.id
                                        )
                                      }
                                    >
                                      {milestoneItem.name}
                                    </button>
                                  </span>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexShrink: 0,
                                  }}
                                >
                                  {(selectedSubMenuPermission === "write" ||
                                    selectedSubMenuPermission === "admin") && !isBulkEditMode&&(
                                    <div
                                      style={{
                                        textAlign: "left",
                                        paddingLeft: "20px",
                                        paddingTop: "10px",
                                        paddingBottom: "10px",
                                        marginRight: "10px",
                                        display: 'flex',
                                      }}
                                    >
                                      <button
                                        style={{
                                          display: "flex",
                                          border: "none",
                                          backgroundColor: "transparent",
                                          cursor: "pointer",
                                          alignItems: "center",
                                          color: "#0a5f59",
                                          fontSize:
                                            "var(--sub-heading-font-size)",
                                          whiteSpace: "nowrap",
                                        }}
                                        type="button"
                                        onClick={() => {
                                          openTaskNav(
                                            false,
                                              "Add New Task",
                                            milestoneItem.id,
                                            milestoneIndex,
                                            impIndex,
                                            taskIndex,
                                            impItem.id
                                          );
                                        }}
                                      >
                                        <img
                                          src={AddColorIcon}
                                          width={16}
                                          height={16}
                                          style={{ marginRight: "5px" }}
                                        />
                                        Add Task
                                      </button>
                                      {aiButtonEnabled && <button
                                        className="ai-button"
                                        type="button"
                                        // onClick={() => setSimpModel(functionIndex, false)}
                                        onClick={() => {
                                          handleShowAiTaskGenerateOpen();
                                          setSelectedMilestoneForAI(milestoneItem);
                                          setShowAiTaskGenerate(true);
                                        }}
                                      >
                                        <span className="ai-button-icon" >
                                          <svg width="0" height="0">
                                            <defs>
                                              <linearGradient id="aiIconGradient" gradientTransform="rotate(90)">
                                                <stop offset="0%" stopColor="#A47CF3" />
                                                <stop offset="100%" stopColor="#683FEA" />
                                              </linearGradient>
                                            </defs>
                                          </svg>
                                          <HiSparkles size={20} />
                                        </span>

                                        <span className="ai-button-text" >Generate with AI</span>

                                      </button>}
                                    </div>
                                  )}
                                  <img
                                    alt="chevronright"
                                    src={ChevronRight}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      if(!isBulkEditMode){
                                      setIsSidebarOpen(true);
                                      handleChevronClick(
                                        milestoneItem,
                                        "Edit Milestone",
                                        impIndex,
                                        milestoneIndex,
                                        impItem.name
                                      );

                                      setHighlightedRowIndex(milestoneItem.id);
                                    }}
                                  }
                                  />
                                </div>
                              </div>
                            </td>
                            <td style={{ textAlign: "center", width: "6%" }}>
                              <div>
                                {milestoneItem.assigned_to.length > 0 &&
                                milestoneItem.assigned_to.find(
                                  (item) => item.is_active
                                ) ? (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip
                                        id={`tooltip-${
                                          milestoneItem.assigned_to.find(
                                            (item) => item.is_active
                                          ).label
                                        }`}
                                      >
                                        {
                                          milestoneItem.assigned_to.find(
                                            (item) => item.is_active
                                          ).label
                                        }
                                      </Tooltip>
                                    }
                                  >
                                      <div style={{
                                        position: "relative",
                                        display: "inline-block",
                                        // margin: "10px",
                                      }}>
                                        <img
                                      style={{ margin: "10px" }}
                                      alt=""
                                      src={createImageFromInitials(
                                        30,
                                        milestoneItem.assigned_to.find(
                                          (item) => item.is_active
                                        ).label,
                                        getRandomColor(
                                          milestoneItem.assigned_to.find(
                                            (item) => item.is_active
                                          ).label
                                        )
                                      )}
                                    />
                                        { (milestoneItem.assigned_to.find((item) => item.is_active)?.status ===
                                   "Inactive" ||milestoneItem.assigned_to.find((item) => item.is_active)?.bi_mapping===false)&&(
                                            < TiDelete
                                              size={14}
                                              style={{
                                                position: "absolute",
                                                bottom: "10px",
                                                right: "10px",
                                                background: "#fff",
                                                borderRadius: "50%",
                                                color: "#DC2626",
                                                padding: "1px",
                                              }}
                                            />
                                          )}
                                      </div>
                                    </OverlayTrigger>
                                ) : (
                                  <img
                                    alt=""
                                    src={Assign}
                                    style={{ margin: "10px" }}
                                  />
                                )}
                              </div>
                            </td>
                            <td style={{ textAlign: "center", width: "10%" }}>
                              <div>
                                {milestoneItem.due_date ? (
                                  <p
                                    style={{
                                      marginBottom: "0px",
                                    }}
                                  >
                                    {milestoneItem.due_date}
                                  </p>
                                ) : (
                                  <p
                                    style={{
                                      textAlign: "center",
                                      color: "gray",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    Due Date
                                  </p>
                                )}
                              </div>
                            </td>
                            <td style={{ textAlign: "center", width: "8%" }}>
                              <div className="step-percentage">
                                {milestoneItem.progress}%
                              </div>
                            </td>
                            <td style={{ width: "8%", textAlign: "left" }}>
                              <div
                                style={{
                                  whiteSpace: "nowrap",
                                  textAlign: "left",
                                }}
                              >
                                {createStatus(milestoneItem.status)}
                              </div>
                            </td>
                            <td style={{ width: "8%", textAlign: "left" }}>
                              {createPriority(milestoneItem.priority)}
                            </td>
                          </tr>
                           {(selectedSubMenuPermission === "write" || selectedSubMenuPermission === "admin") &&isBulkEditMode && !collapsedItems[milestoneItem.id] && (
                            <tr style={{ backgroundColor: "#E5F2F1" }}>
                              <td
                                colSpan={6}
                                style={{
                                  padding: "8px 0 8px 30px",
                                  borderTop: "1px solid #0A5F59",
                                  borderBottom: "1px solid #0A5F59",
                                  textAlign: "left"
                                }}
                              >
                                {milestoneItem.tasks?.length > 0 && (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px"
                                  }}
                                >
                                  <Checkbox
                                    size="small"
                                    checked={isMilestoneFullySelected(milestoneItem)}
                                    onChange={() => handleSelectMilestoneTasks(milestoneItem)}
                                    sx={{
                                      padding: "0",
                                      color: "#9CA3AF",
                                      "&.Mui-checked": { color: "#0A5F59" },
                                    }}
                                  />

                                  <span style={{ fontSize: "13px", fontWeight: "500", color: "#0A5F59" }}>
                                    Select all tasks under this milestone
                                  </span>
                                </div>)}
                              </td>
                            </tr>
                          )}
                          {milestoneItem &&
                          milestoneItem.tasks &&
                          milestoneItem?.tasks?.length > 0 ? (
                            !collapsedItems[milestoneItem?.id] &&
                            milestoneItem?.tasks?.map((tasks, taskIndex) => (
                              <>
                                <tr
                                  key={taskIndex}
                                  style={{
                                    backgroundColor:
                                      highlightedRowIndex === tasks.id
                                        ? "#D9F6E4"
                                        : "",
                                    width: "100%",
                                  }}
                                >
                                  <td
                                    style={{
                                      paddingLeft: "20px !important",
                                      width: "60%",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        paddingLeft: "30px",
                                      }}
                                    >
                                       {isBulkEditMode &&tasks.can_select&&(
                                          <Checkbox
                                            size="small"
                                            checked={selectedTaskIds.some((item) => item.id === tasks.id)}
                                            onChange={() =>
                                              handleSelectTaskRow(tasks.id, milestoneItem.id, tasks.name||"","task",tasks.subtasks || [])
                                            }
                                            sx={{
                                              padding: "4px",
                                              marginRight: "6px",
                                              color: "#9CA3AF", 
                                              "&.Mui-checked": {
                                                color: "#0A5F59",
                                              },
                                            }}
                                          />
                                        )}
                                      <img
                                        src={Repeat}
                                        width={"24px"}
                                        style={{ marginRight: "8px" }}
                                      />
                                      <div
                                        onBlur={() =>
                                          handleToggleTaskEditing(
                                            impIndex,
                                            milestoneIndex,
                                            taskIndex,
                                            false
                                          )
                                        }
                                        style={{
                                          flex: 1,
                                          padding: "6px 8px",
                                          marginRight: "8px",
                                          textAlign: "left",
                                          cursor: "pointer",
                                          width: "100px",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          textAlign: "left"
                                        }}
                                        
                                        title={tasks.name}
                                        onClick={() => {
                                          if(!isBulkEditMode){
                                          openTaskNav(
                                            tasks,
                                            "Edit Task",
                                            milestoneItem.id,
                                            milestoneIndex,
                                            impIndex,
                                            taskIndex
                                          );
                                          setHighlightedRowIndex(tasks.id);
                                        }}
                                      }
                                      >
                                        {tasks.name}
                                      </div>
                                      {tasks?.subtasks &&
                                        tasks.subtasks?.length > 0 && (
                                          <>
                                            <span
                                              style={{ marginRight: "5px" }}
                                            >
                                              {tasks?.subtasks?.length}
                                            </span>
                                            <img
                                              alt="subtaskicon"
                                              src={SubtasksIcon}
                                              style={{
                                                cursor: "pointer",
                                                paddingTop: "0px",
                                              }}
                                              width={"15px"}
                                              onClick={() => {
                                                if(!isBulkEditMode){
                                                openTaskNav(
                                                  tasks,
                                                  "Edit Task",
                                                  milestoneItem.id,
                                                  milestoneIndex,
                                                  impIndex,
                                                  taskIndex
                                                );
                                                setHighlightedRowIndex(
                                                  tasks.id
                                                );
                                              }}
                                            }
                                            />
                                          </>
                                        )}
                                      {tasks.recurring_data && (
                                        <OverlayTrigger
                                          placement="top"
                                          delay={{ show: 150, hide: 150 }}
                                          overlay={
                                            <Tooltip id={`repeat-tooltip-${tasks.id}`}>
                                              <TbRepeat size={14}  />
                                              <span>
                                                {tasks.recurring_data?.frequency}
                                              </span>

                                            </Tooltip>
                                          }
                                        >
                                          <span style={{ display: "inline-flex", alignItems: "center", cursor: "pointer" , marginLeft: tasks?.subtasks && tasks.subtasks.length > 0 ? "8px" : "0px",}}>
                                            <TbRepeat
                                              size={18}
                                              color="#0E7C66"
                                              style={{ marginRight: "4px", flexShrink: 0 }}
                                            />
                                          </span>
                                        </OverlayTrigger>
                                      )}
     
                                      <img
                                        alt="chevronright"
                                        src={ChevronRight}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          if(!isBulkEditMode){
                                          openTaskNav(
                                            tasks,
                                            "Edit Task",
                                            milestoneItem.id,
                                            milestoneIndex,
                                            impIndex,
                                            taskIndex
                                          );
                                          setHighlightedRowIndex(tasks.id);
                                        }}
                                      }
                                      />
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      width: "8%",
                                      textAlign: "center",
                                    }}
                                  >
                                    <div>
                                      {tasks.assigned_to.length &&
                                      tasks.assigned_to.find(
                                        (item) => item.is_active
                                      ) ? (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip
                                              id={`tooltip-${
                                                tasks.assigned_to.find(
                                                  (item) => item.is_active
                                                ).label
                                              }`}
                                            >
                                              {
                                                tasks.assigned_to.find(
                                                  (item) => item.is_active
                                                ).label
                                              }
                                            </Tooltip>
                                          }
                                        >
                                            <div style={{
                                              position: "relative",
                                              display: "inline-block",
                                              // margin: "10px",
                                            }}>
                                              <img
                                            style={{ margin: "10px" }}
                                            alt=""
                                            src={createImageFromInitials(
                                              30,
                                              tasks.assigned_to.find(
                                                (item) => item.is_active
                                              ).label,
                                              getRandomColor(
                                                tasks.assigned_to.find(
                                                  (item) => item.is_active
                                                ).label
                                              )
                                            )}
                                          />
                                              {(tasks.assigned_to.find((item) => item.is_active)?.status ===
                            "Inactive" ||tasks.assigned_to.find((item) => item.is_active)?.bi_mapping===false)&&(
                                                  < TiDelete
                                                    size={14}
                                                    style={{
                                                      position: "absolute",
                                                      bottom: "10px",
                                                      right: "10px",
                                                      background: "#fff",
                                                      borderRadius: "50%",
                                                      color: "#DC2626",
                                                      padding: "1px",
                                                    }}
                                                  />
                                                )}
                                            </div>
                                          </OverlayTrigger>
                                      ) : (
                                        <img
                                          alt=""
                                          src={Assign}
                                          style={{ margin: "10px" }}
                                        />
                                      )}
                                    </div>
                                  </td>
                                  <td
                                    style={{ textAlign: "center", width: "8%" }}
                                  >
                                    <div>
                                      {tasks.due_date ? (
                                        <p
                                          style={{
                                            marginBottom: "0px",
                                          }}
                                        >
                                          {tasks.due_date}
                                        </p>
                                      ) : (
                                        <p
                                          style={{
                                            textAlign: "center",
                                            color: "gray",
                                            marginBottom: "0px",
                                          }}
                                        >
                                          Due Date
                                        </p>
                                      )}
                                    </div>
                                  </td>
                                  <td
                                    style={{ textAlign: "center", width: "8%" }}
                                  >
                                    <div className="step-percentage">
                                      {tasks.progress}%
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      whiteSpace: "nowrap",
                                      textAlign: "left",
                                      width: "8%",
                                    }}
                                  >
                                    {createStatus(tasks.status)}
                                  </td>
                                  <td
                                    style={{ textAlign: "left", width: "8%" }}
                                  >
                                    {createPriority(tasks.priority)}
                                  </td>
                                </tr>
                                {tasks?.subtasks?.map(
                                  (subtask, subtaskIndex) => (
                                    <tr
                                      key={subtaskIndex}
                                      style={{
                                        backgroundColor:
                                          highlightedRowIndex === subtask.id
                                            ? "#D9F6E4"
                                            : "",
                                        width: "100%",
                                      }}
                                    >
                                      <td
                                        style={{
                                          paddingLeft: "20px !important",
                                          width: "60%",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "left",
                                            paddingLeft: "70px",
                                          }}
                                        >
                                          { isBulkEditMode &&subtask.can_select&& (
                                            <Checkbox
                                              size="small"
                                              checked={selectedTaskIds.some((item) => item.id === subtask.id)}
                                              onChange={() => handleSelectTaskRow(subtask.id, tasks.id, subtask.name||"","sub_task")}
                                              sx={{
                                                padding: "2px",
                                                marginRight: "4px",
                                                color: "#9CA3AF",
                                                "&.Mui-checked": { color: "#0A5F59" },
                                              }}
                                            />
                                          )}
                                          <img
                                            src={Repeat}
                                            width={"24px"}
                                            style={{ marginRight: "8px" }}
                                          />
                                          <div
                                            onBlur={() =>
                                              handleToggleTaskEditing(
                                                impIndex,
                                                milestoneIndex,
                                                subtaskIndex,
                                                false
                                              )
                                            }
                                            style={{
                                              flex: 1,
                                              padding: "6px 8px",
                                              marginRight: "8px",
                                              textAlign: "left",
                                              cursor: "pointer",
                                              width: "100px",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              textAlign: "left"
                                            }}
                                            title={subtask.name}
                                            onClick={() => {
                                              if(!isBulkEditMode){
                                              openTaskNav(
                                                subtask,
                                                "Edit Sub Task",
                                                milestoneItem.id,
                                                milestoneIndex,
                                                impIndex,
                                                taskIndex,      // parent task index
                                                null,
                                                subtaskIndex 
                                              );
                                              setHighlightedRowIndex(
                                                subtask.id
                                              );
                                            }}
                                          }
                                          >
                                            {subtask.name}
                                          </div>
                                          {subtask?.subtasks &&
                                            subtask.subtasks?.length > 0 && (
                                              <>
                                                <span
                                                  style={{ marginRight: "5px" }}
                                                >
                                                  {subtask?.subtasks?.length}
                                                </span>
                                                <img
                                                  alt="subtaskicon"
                                                  src={SubtasksIcon}
                                                  style={{
                                                    cursor: "pointer",
                                                    paddingTop: "0px",
                                                  }}
                                                  width={"15px"}
                                                  onClick={() => {
                                                    if(!isBulkEditMode){
                                                    openTaskNav(
                                                      subtask,
                                                      "Edit Sub Task",
                                                      milestoneItem.id,
                                                      milestoneIndex,
                                                      impIndex,
                                                      taskIndex,      // parent task index
                                                      null,
                                                      subtaskIndex 
                                                    );
                                                    setHighlightedRowIndex(
                                                      subtask.id
                                                    );
                                                  }}
                                                }
                                                />
                                              </>
                                            )}
                                          {subtask.recurring_data && (
                                            <OverlayTrigger
                                              placement="top"
                                              delay={{ show: 150, hide: 150 }}
                                              overlay={
                                                <Tooltip id={`repeat-tooltip-${subtask.id}`}>
                                                  <TbRepeat size={14} />
                                                  <span>
                                                    {subtask.recurring_data?.frequency}
                                                  </span>

                                                </Tooltip>
                                              }
                                            >
                                              <span style={{ display: "inline-flex", alignItems: "center", cursor: "pointer" }}>
                                                <TbRepeat
                                                  size={18}
                                                  color="#0E7C66"
                                                  style={{ marginRight: "4px", flexShrink: 0 }}
                                                />
                                              </span>
                                            </OverlayTrigger>
                                          )}
                                          <img
                                            alt="chevronright"
                                            src={ChevronRight}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              if(!isBulkEditMode){
                                              openTaskNav(
                                                subtask,
                                                "Edit Sub Task",
                                                milestoneItem.id,
                                                milestoneIndex,
                                                impIndex,
                                                taskIndex,      // parent task index
                                                null,
                                                subtaskIndex 
                                              );
                                              setHighlightedRowIndex(
                                                subtask.id
                                              );
                                            }}
                                          }
                                          />
                                        </div>
                                      </td>
                                      <td
                                        style={{
                                          width: "8%",
                                          textAlign: "center",
                                        }}
                                      >
                                        <div>
                                          {subtask.assigned_to.length &&
                                          subtask.assigned_to.find(
                                            (item) => item.is_active
                                          ) ? (
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-${
                                                    subtask.assigned_to.find(
                                                      (item) => item.is_active
                                                    ).label
                                                  }`}
                                                >
                                                  {
                                                    subtask.assigned_to.find(
                                                      (item) => item.is_active
                                                    ).label
                                                  }
                                                </Tooltip>
                                              }
                                            >
                                                <div style={{
                                                  position: "relative",
                                                  display: "inline-block",
                                                  // margin: "10px",
                                                }}>
                                                  <img
                                                style={{ margin: "10px" }}
                                                alt=""
                                                src={createImageFromInitials(
                                                  30,
                                                  subtask.assigned_to.find(
                                                    (item) => item.is_active
                                                  ).label,
                                                  getRandomColor(
                                                    subtask.assigned_to.find(
                                                      (item) => item.is_active
                                                    ).label
                                                  )
                                                )}
                                              />
                                                  {(subtask.assigned_to.find((item) => item.is_active)?.status ===
                            "Inactive" ||subtask.assigned_to.find((item) => item.is_active)?.bi_mapping===false)&&(
                                                      < TiDelete
                                                        size={14}
                                                        style={{
                                                          position: "absolute",
                                                          bottom: "10px",
                                                          right: "10px",
                                                          background: "#fff",
                                                          borderRadius: "50%",
                                                          color: "#DC2626",
                                                          padding: "1px",
                                                        }}
                                                      />
                                                    )}
                                                </div>
                                              </OverlayTrigger>
                                          ) : (
                                            <img
                                              alt=""
                                              src={Assign}
                                              style={{ margin: "10px" }}
                                            />
                                          )}
                                        </div>
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          width: "8%",
                                        }}
                                      >
                                        <div>
                                          {subtask.due_date ? (
                                            <p>{subtask.due_date}</p>
                                          ) : (
                                            <p
                                              style={{
                                                color: "gray",
                                                marginBottom: "0px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Due Date
                                            </p>
                                          )}
                                        </div>
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          minWidth: "8%",
                                        }}
                                      >
                                        <div className="step-percentage">
                                          {subtask.progress}%
                                        </div>
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "left",
                                          width: "8%",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {createStatus(subtask.status)}
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "left",
                                          width: "8%",
                                        }}
                                      >
                                        {createPriority(subtask.priority)}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </>
                            ))
                          ) : (
                            <div style={{ padding: "10px 40px" }}>
                              No tasks yet.
                            </div>
                          )}
                        </tbody>
                      </>
                    ))}
                  </table>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div style={{ marginTop: "10px" }}>
            <p>No tasks yet.</p>
          </div>
        )}
      </motion.div>
       <Drawer
              sx={{
                "& .MuiDrawer-paper": {
                  width: "50%",
                  // padding: 2,
                  height: "calc(100vh-63px)",
                  marginTop: "64px",
                },
              }}
              slotProps={{
                backdrop: {
                  sx: {
                    backgroundColor: "transparent",
                  },
                },
              }}
              PaperProps={{
                sx: {
                  boxShadow: "none",
                  borderLeft: "1px solid lightGray",
                },
              }}
              anchor="right"
              transitionDuration={{ enter: 500, exit: 300 }}
              SlideProps={{
                easing: {
                  enter: "cubic-bezier(0.0, 0, 0.2, 1)", // standard
                  exit: "cubic-bezier(0.4, 0.0, 1, 1)", // ease-out
                },
              }}
              open={showAiGenerate}
              onClose={handleShowAiTaskGenerateClose}
            >
              {/* Header */}
              <GenerateMilestoneTasksPanel
                handleshowAiGenerateClose={handleShowAiTaskGenerateClose}
                milestoneItem={selectedMilestoneForAI} /> 
            </Drawer>
            <Drawer
              anchor="right"
              open={aiEdit}
              onClose={handleAiEdit}
              transitionDuration={{ enter: 500, exit: 300 }}
              SlideProps={{
                easing: {
                  enter: "cubic-bezier(0.0, 0, 0.2, 1)", // standard
                  exit: "cubic-bezier(0.4, 0.0, 1, 1)", // ease-out
                  transition: "width 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
                },
              }}
              PaperProps={{
                sx: {
                  boxShadow: "none",
                  borderLeft: "1px solid lightGray",
                },
              }}
              sx={{
                "& .MuiDrawer-paper": {
                  // width: aiFullScreenMode ? 'calc(100% - 50px)' : '50%',
                  // transition: "width 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
                  padding: 0,
                  height: "calc(100vh - 50px)",
                  marginTop: "64px",
                  width: aiFullScreenMode ? "calc(100% - 50px)" : "50%",
                  // paddingBottom: "64px",
                },
              }}
              slotProps={{
                backdrop: {
                  sx: {
                    backgroundColor: "transparent",
                  },
                },
              }}
            >
              <AiWorkboardEditDrawer
                milestones={generatedTasks}
                handleAiEdit={handleAiEdit}
                // updateGoal={updateGoal}
                // updateMilestone={updateMilestone}
                aiFullScreenMode={aiFullScreenMode}
                setAiFullScreenMode={setAiFullScreenMode}
                dispatch={dispatch}
                aiFunctionId={selectedMilestoneForAI?.id}
              />
            </Drawer>
      
      {isTaskSidebarOpen && (
        <TaskSidebar
          isNewTask={isNewTask}
          taskType={taskType}
          setTaskType={(value) => setTaskType(value)}
          subTaskId={subTaskId}
          setSubTaskId={(value) => setSubTaskId(value)}
          selectedTaskMilestoneId={selectedTaskMilestoneId}
          breadcrumbs={breadcrumbs}
          empData={empData}
          statusData={statusData}
          mileStonesData={mileStonesData}
          priorityData={priorityData}
          selectedTaskId={selectedTaskId}
          onClose={closeTaskNav}
          handleTaskDelete={handleTaskDelete}
          isSubTaskVisible={isSubTaskVisible}
          setIsSubTaskVisible={(value) => setIsSubTaskVisible(value)}
          handleDuplicateTaskClick={(id, title) =>
            handleDuplicateTaskClick(id, title)
          }
          handleDTPopupShow={() => handleDTPopupShow()}
        />
      )}
      {isSidebarOpen && (
        <XLExeuctionPlanSidebar
          userPermission={userPermission}
          userDueDatePermission={userDueDatePermission}
          workboard={true}
          isEdit={true}
          data={milestoneData}
          type={"milestone"}
          placeholder={"Write a milestone name"}
          empData={empData}
          statusData={statusData}
          priorityData={priorityData}
          breadcrumbs={breadcrumbs}
          milestonedataId={milestoneData.id}
          impIndex={currentImperativeIndex}
          milestoneIndex={currentMilestoneIndex}
          handleMilestoneEdit={handleMilestoneEdit}
          handleMilestoneDelete={handleMilestoneDelete}
          onClose={() => {
            setIsSidebarOpen(false);
            setHighlightedRowIndex("");
          }}
          setIsSidebarOpen={(value) => {
            setIsSidebarOpen(value);
          }}
          handleDuplicateTaskClick={(id, title) =>
            handleDuplicateTaskClick(id, title)
          }
          handleDTPopupShow={() => handleDTPopupShow()}
          simpItemName={imperativeName}
        />
      )}
      {showDuplicateTaskPopup && (
        <DuplicateTaskPopup
          ModalTitle="Duplicate Task"
          handleClose={() => handleDTPopupClose()}
          show={showDuplicateTaskPopup}
          duplicateTaskName={duplicateTaskName}
          duplicateTaskId={duplicateTaskId}
        />
      )}
      <div>{selectedHelpInfoSidebar && <SideNavHelpInfo />}</div>
      <Dialog
        open={showBulkModal}
        maxWidth="xs"
        fullWidth
       // disableEnforceFocus={true}
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ backgroundColor: "var(--sub-menu-bg-color)", textAlign: "center", fontWeight: "600", fontSize: "16px" }}>  
          Bulk Edit{" "}
          <strong
            style={{
              backgroundColor: "#f4fdf7",
              padding: "4px 8px",
              borderRadius: "5px",
            }}
          >
            {selectedTaskIds.length}
          </strong>{" "}
          {selectedTaskIds.length === 1 ? "Task" : "Tasks"}
        </DialogTitle>
       
        <DialogContent sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 3, paddingTop: "10px !important" }}>
          {/* OWNER */}
          <div>
            <label style={{ fontWeight: "600", marginBottom: "5px", fontSize: "13px" }}>Owner</label>
            <Select
              options={empData}
              value={empData?.find(opt => opt.value === bulkFields.assigned_to) || null}
              placeholder="Select Owner"
              isClearable
              menuPortalTarget={document.body}
              styles={customStylesTable}
              onChange={(val) => setBulkFields(prev => ({ ...prev, assigned_to: val ? val.value : null }))}
            />
          </div>
            {/* STATUS */}
          <div>
            <label style={{ fontWeight: "600", marginBottom: "5px", fontSize: "13px" }}>Status</label>
            <Select
              options={statusOptions}
              value={statusOptions?.find(opt => opt.value === bulkFields.status) || null}
              placeholder="Select Status"
              isClearable
              menuPortalTarget={document.body}
              styles={customStylesTable}
              onChange={(val) => setBulkFields(prev => ({ ...prev, status: val ? val.value : null }))}
            />
            {(bulkFields.status === "Completed")
               && hasDependentSubtasks && (
                <div
                  style={{
                    marginTop: "6px",
                    fontSize: "12px",
                    color: "#b45309",
                    backgroundColor: "#fffbeb",
                    border: "1px solid #fde68a",
                    borderRadius: "4px",
                    padding: "6px 8px"
                  }}
                >
                 <strong>Note:</strong> Completed status is applicable only when the task has no subtasks or all associated subtasks are completed.
                </div>
              )}
          </div>
          {/* PRIORITY */}
          <div>
            <label style={{ fontWeight: "600", marginBottom: "5px", fontSize: "13px" }}>Priority</label>
            <Select
              options={priorityOptions}
              value={priorityOptions?.find(opt => opt.value === bulkFields.priority) || null}
              placeholder="Select Priority"
              isClearable
              menuPortalTarget={document.body}
              styles={customStylesTable}
              onChange={(val) => setBulkFields(prev => ({ ...prev, priority: val ? val.value : null }))}
            />
          </div>
          {/* PROGRESS */}
          <div>
            <label style={{ fontWeight: "600", marginBottom: "5px", fontSize: "13px" }}>Progress</label>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              // width: "100%",
              marginLeft: "15px",
            }}
          >
            <StepProgressBar
              steps={steps}
              setCurrentStep={0}
              currentStep={bulkFields.progress !== null && bulkFields.progress !== undefined ? (Number(bulkFields.progress) / 20) : currentStep}// currentstep=40/20 =2 current setp 2=40
              onStepClick={handleBulkProgressClick}
              selectedSubMenuPermission="write"
            />
            <div className="step-percentage">
              {bulkFields.progress !== null && bulkFields.progress !== undefined
                ? bulkFields.progress
                : (currentStep * 20)}%
            </div>
          </div>
          {/* START DATE */}
          <div>
            <label style={{ fontWeight: "600", marginBottom: "5px", fontSize: "13px" }}>Start Date</label>
            <div style={{ position: "relative", width: "100%" }}>
              <DatePicker
                wrapperClassName="w-100"
                dateFormat="yyyy-MM-dd"
                placeholderText="YYYY-MM-DD"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                popperPlacement="top-start"
                selected={bulkFields.start_date ? new Date(bulkFields.start_date) : null} 
                onChange={(d) =>setBulkFields((prev) => ({...prev,start_date: d? new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().split("T")[0]: "",}))}
                customInput={
                  <input
                    className="form-control due-date-select"
                    style={{
                      width: "100%",
                      fontSize: "14px",
                    }}
                    readOnly
                  />
                }
              />
               <SlCalender
                size={14}
                color={bulkFields.start_date ? "#28a745" : "gray"}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "40%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                }}
              />
            </div>
          </div>
          {/* END DATE (DUE DATE) */}
          <div>
            <label style={{ fontWeight: "600", marginBottom: "5px", fontSize: "13px" }}>Due Date</label>
            <div style={{ position: "relative", width: "100%" }}>
              <DatePicker
                wrapperClassName="w-100"
                dateFormat="yyyy-MM-dd"
                placeholderText="YYYY-MM-DD"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                selected={bulkFields.due_date ? new Date(bulkFields.due_date) : null}
                onChange={(d) => setBulkFields((prev) => ({ ...prev, due_date: d ? new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().split("T")[0] : "", }))}
                customInput={
                  <input
                    className="form-control due-date-select"
                    style={{
                      width: "100%",
                      fontSize: "14px",
                    }}
                    readOnly
                  />
                }
              />
              <SlCalender
                size={14}
                color={bulkFields.due_date ? "#28a745" : "gray"}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "18%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                }}
              />
               <div
                  style={{
                    marginTop: "6px",
                    fontSize: "12px",
                    color: "#b45309",
                    backgroundColor: "#fffbeb",
                    border: "1px solid #fde68a",
                    borderRadius: "4px",
                    padding: "6px 8px"
                  }}
                >
                  <strong>Note:</strong> Only permitted tasks will be updated for the due date
                </div>

            </div>
          </div>
         
          {/* MODAL CONTROL ACTIONS */}
          <div style={{ display: "flex", justifyContent: "end", gap: "12px", marginTop: "15px" }}>
            <Button
              variant="light"
              onClick={() => { setShowBulkModal(false); setBulkFields({ assigned_to: null, status: null, priority: null, start_date: null, progress: null,due_date:null}); }}
              style={{ border: "1px solid gray", fontSize: "13px" }}
            >
              Cancel
            </Button>
            <Button style={{ backgroundColor: "#0A5F59", color: "white", borderColor: "#0A5F59", fontSize: "13px" }} onClick={handleBulkSubmitSave}>
              Save
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {/* {isDropdownVisible && (
        <div
          className="workboard-actions-container"
          ref={dropdownRef}
          style={{
            backgroundColor: isNestedVisible ? "#f8f8f8" : "",
          }}
        >
          <div onClick={toggleNested}>
            <span style={{ paddingRight: "40px" }}>Export CSV</span>
            <i className="bi bi-chevron-right"></i>
          </div>
        </div>
      )} */}
      {/* {isNestedVisible && (
        <div className="workboard-actions-nested-container" ref={dropdownRef}>
          {tools.map((tool) => (
            <div
              key={tool.name}
              onClick={() => handleCSVButtonClick(tool.value)}
              className="workboard-action-item"
            >
              <img src={tool.imgSrc} width={20} alt={tool.name} />
              <label style={{ marginLeft: "10px" }}>{tool.name}</label>
            </div>
          ))}
        </div>
      )} */}
    </div>
  );
  if (!localStorage.getItem("authenticated")) {
    return (
      <div>
        <Login />
      </div>
    );
  } else {
    return (
      <>
        <MainComponent
          maincontent={content}
          showSelector={true}
          showButtons={true}
          handleNext={handleClick}
          handleBackButton={handleBack}
          // hideBackButton={true}
          showProducts={true}
          breadcrumbParent={"GTM Execution"}
          breadcrumbChild={"Workboard"}
          documentName={"Workboard"}
          helpKey={keys["Workboard"].Name}
          image={"question"}
          showBulkEditOptionButton={(selectedSubMenuPermission === "write" || selectedSubMenuPermission === "admin")}
          isBulkEditMode={isBulkEditMode}
          handleBulkEditToggle={() => {
          if (!isBulkEditMode) {
             setIsBulkEditMode(true);
             dispatch(getWorkboardDetails(localStorage.getItem("bi_id"),localStorage.getItem("product_id"),localStorage.getItem("selectedfunction"),radioValue === "2" ? "my_tasks" : "",filters));}
          else{
            setIsBulkEditMode(false);
            setSelectedTaskIds([]);
          }  
          }}
        />
      </>
    );
  }
}

export default Workboard;


const AiWorkboardEditDrawer = ({
  milestones,
  handleAiEdit,
  aiFullScreenMode,
  setAiFullScreenMode,
  dispatch,
  aiFunctionId
}) => {
  const [localTasks, setLocalTasks] = useState(milestones);

  useEffect(() => {
    setLocalTasks(milestones);
  }, [milestones]);

 const updateTaskField = (index, field, value) => {
    setLocalTasks(prev => {
      const copy = [...prev];
      copy[index] = { ...copy[index], [field]: value };
      return copy;
    });
  };

  

  const saveAll = (e) => {
    // THIS is your final payload
    e.preventDefault()

    dispatch(postAiTaskGeneratedGoals(localStorage.getItem('bi_id'),localStorage.getItem('product_id'),aiFunctionId,localStorage.getItem('selectedfunction'),localTasks))
    
  };

  return (
    <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px", borderBottom: "1px solid lightGray" }}>
        <div style={{ maxWidth: "60%", textOverflow: "ellipsis", overflow: "hidden", paddingTop: "4px", fontSize: "var(--sub-heading-font-size)", fontWeight: "var(--heading-font-weight)" }}>
          Review and Edit Generated Tasks
        </div>
        <div>
          {!aiFullScreenMode ? (
                    <a href="#" className="fullscreen" style={{fontSize:'25px', marginRight: '10px', color:'gray'}} onClick={()=> setAiFullScreenMode(true)}>
                      <AiOutlineCaretRight />
                    </a>
                  ) : (
                    <a href="#" className="fullscreen" style={{fontSize:'25px', marginRight: '10px', color:'gray'}} onClick={()=> setAiFullScreenMode(false)}>
                      <AiOutlineCaretLeft />
                    </a>
                  )}
          <Button color="inherit" onClick={() => { handleAiEdit();setTimeout(() => {setAiFullScreenMode(false);}, 1000); }} style={{ border: "2px solid darkgray", borderRadius: "10px", color: "gray", backgroundColor: "white" }}>
            Cancel
          </Button>
          <Button type="submit" form="ai-edit-form" color="inherit"  style={{width:'fit-content', color: "white", backgroundColor: "#0a5f59", border: "3px solid #0a5f59", marginLeft: "20px", padding: "4px 10px" }}>
            Create Tasks
          </Button>
        </div>
      </div>

      {/* Content */}
      <form id="ai-edit-form" onSubmit={saveAll} style={{ display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center", backgroundColor: "whitesmoke", flexGrow: 1, overflowY: "auto", overflowX: "hidden", paddingBottom:'100px' }}>
       {localTasks?.map((task, index) => (
          < div key={index} className="goal-card"> 
              <textarea
                className="goal-milestone"
                value={task.subject}
                required
                onChange={(e) => updateTaskField(index,"subject", e.target.value)}  
              />
              <textarea
                className="ai-description"
                value={task.description}
                onChange={(e) => updateTaskField(index, "description", e.target.value)} 
              />
            </div> 
        ))}
      </form>
    </div>
  );
};

